import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './SyncFusionCalendar.html?raw';
import GenericDialog from '../../GenericDialog/GenericDialog';
import "../../GenericDialog/GenericDialog";
import lang from 'dojo/_base/lang';
import dojoQuery from 'dojo/query';
import dojoDate from 'dojo/date';
import on from 'dojo/on';
import topic from 'dojo/topic';

import * as SyncfusionHelper from "../../../Tools/syncfusionHelper";

import {
    SyncFusionCalendarTypes
} from "./SyncFusionCalendarTypes"
import { ColorHelpers, DateHelpers, HtmlHelpers, TranslationHelpers, ExtraHelpers, FeatureHelpers, } from "../../../../more/Helpers";
import domConstruct from 'dojo/dom-construct';
import { WebcalendarTypes } from "../../moreCoreCalendar/WebCalendarTypes";
import WebcalendarDateInfo from '../../../../WidgetCollection/WebCalendar_TS/DateInfo';

interface TooltipData { tooltipContent: string, hasContent: boolean }

class SyncFusionCalendar extends compose(_WidgetBaseSP) {
    templateString: any = template;
    syncFusionContainer: HTMLElement;

    public scheduleObject: any;
    private itemClickFunction: Function;
    private columnView_bodyText_attribute: string;
    private columnView_headText_attribute: string;
    private autoAdjustHeight: boolean = true;
    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    private itemColorationValues: Array<WebcalendarTypes.ColorValue>;
    //private itemColorationId: string = null;
    private calendarId: string = null;
    private allGroups: Array<SyncFusionCalendarTypes.EventGroup> = [];
    private bShowEndTime: boolean = true;
    private bShowStartTime: boolean = true;
    earliestDate: Date = null;
    latestDate: Date = null;
    private groups: Array<Object> = [];
    private resources: Array<WebcalendarTypes.SyncfusionCalendarResource> = [];
    private resourceGroups: Array<WebcalendarTypes.SyncfusionCalendarResource> = [];
    private events: Array<SyncFusionCalendarTypes.Syncfusion_EventItem<any>>;// Record<string, any> = [];
    currentView: WebcalendarTypes.WebCalendar_ViewModes = WebcalendarTypes.WebCalendar_ViewModes.week;
    scheduleCalendarInterval: number = 1;
    private _isTimelineMode: boolean = false;
    private _visibleDateCells: Array<Element> = [];

    private otherGroupValue = "/x/";
    private otherGroupLabel = (this as any).canTranslate("WebCalendar_GroupValueLabelOther", true) ? (this as any).translate("WebCalendar_GroupValueLabelOther", true) : (this as any).createFontawesomeIcon("fas fa-shapes w3-opacity").outerHTML;

    private selectedDate: Date;
    public scrollDate: Date;
    public enableToolTip: boolean = false;
    public tooltipFetchDataFunction: string | ((classname: string, id: string) => Promise<string | HTMLElement>);
    private scrollDateLocked: boolean = false;
    private timelineRanges: Array<{
        earliestDate: Date,
        latestDate: Date
    }> = [];

    public enableTimelineGroupCollapse: boolean = false;

    /**
     * Loading screen initiations by loading resources:
     * - Events
     * - FilterData
     * - Rooms
     * - ViewMode
     * */
    private loadingProgress: Array<string> = [];

    /**
     * Initiate the scheduler with a default configuration.
     * Further information:
     *  - https://ej2.syncfusion.com/javascript/documentation/api/schedule
     *  - https://ej2.syncfusion.com/javascript/documentation/schedule/getting-started/
     * */

    private _getHeaderIndentTemplate(arg1, arg2, arg3) {
        console.debug(this.id + "_getHeaderIndentTemplate", arg1, arg2, arg3);

        return "<span>HeaderIndent</span>";
    }

    private _getDateRangeTemplate(arg1, arg2, arg3) {
        // bei Timeline X-Achsen-Gruppierung der Slots (darunter liegen bei Detail-Timeline die Uhrzeiten)
        console.debug(this.id + "_getDateRangeTemplate", arg1, arg2, arg3);

        return "<span>DateRange</span>";
    }

    private _createDateInfoContainer(targetNode: HTMLElement, date: Date): HTMLElement {
        if (!targetNode) return;

        try {
            let dateKey = this.dateToString(date, "yyyy-MM-dd");

            let infoContainer = this.UiModder.domConstruct.create("div", {
                "className": "dateInfoContainer"
            }, targetNode, "last");

            infoContainer.setAttribute("data-date", dateKey);

            if (FeatureHelpers.hasFeature("Webcalendar/EnableDateInfoPopup")) {

                this.UiModder.domClass.add(targetNode, "clickableDate");
                targetNode.setAttribute("data-date", dateKey);
            }


            //console.debug("_createDateInfoContainer", targetNode, infoContainer);

            return infoContainer;
        } catch (ex) {
            console.warn("_createDateInfoContainer failed", ex);
        }
        return null;
    }

    private _getMonthCellHeaderTemplate(arg1: { date: Date, type: string }, arg2, arg3) {
        // Nummerierung der Tage in Monatsansicht und Minimonate bei Jahresansicht

        // PROBLEM: wir erhalten keine Infos, welcher Monat denn eigentlich gefragt wäre!
        // bei Jahresansicht muss jeder Minimonat wissen, ob ein Tag zum Monat gehört oder zum Vormonat/Folgemonat
        // die Info gibts hier nicht. deshalb diesen Formatter im Cellrender-Event belassen!

        console.debug(this.id + "_getMonthCellHeaderTemplate", arg1, arg2, arg3);
        let node = this.UiModder.domConstruct.create("span", {
            className: "monthCellHeaderLabel",
            innerHTML: this.dateToString(arg1.date, "dd")
        });

        if (this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.year) {

        } else {


            // am Monatsersten das Label korrigieren - ist sonst immer englisch
            if (arg1.date.getDate() == 1) {
                node.innerHTML = this.dateTimeToString(arg1.date, "dd. MMMM");
                this.UiModder.domClass.add(node, "bold firstInMonth");
            }
        }
        return node.outerHTML;
    }
    private _getDayHeaderTemplate(arg1: { date: Date, type: string }, arg2, arg3) {
        //console.debug(this.id + "_getDayHeaderTemplate", arg1, arg2, arg3);
        let cellDate = arg1.date;
        if (this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.timelineYear) {

            // dieses Callback kommt auch in Jahrestimeline!
            // dann gibts aber gschissene Bugs und statt Montag steht Dienstag drin etc!
            // wahrscheinlich wegen internem Zeitzonenhandling, buggy wie sonst was
            // inzwischen hilft den Offset zurückzurechnen:
            let offset = arg1.date.getTimezoneOffset();
            cellDate = new Date(arg1.date.valueOf() + offset * 1000 * 60);
        }

        // Einzeltag in den Minimonaten der Jahresansicht
        let node = this.UiModder.domConstruct.create("span", {
            className: "dayHeaderLabel",
            innerHTML: cellDate.toLocaleDateString(undefined, { weekday: 'short' })
        });

        this.UiModder.domClass.toggle(node, "date-weekend", cellDate.getDay() == 0 || cellDate.getDay() == 6); // wochenende


        return node.outerHTML;

    }
    private _getDateHeaderTemplate(arg1: { date: Date, type: string }, arg2, arg3) {
        //console.debug(this.id + "_getDateHeaderTemplate", arg1, arg2, arg3);
        // Wochentag-Überschrift (Montag-Sonntag) bei Wochenansicht
        // und bei Dateil-Timeline
        // gebraucht wird Wochentag + Datum!

        let isStartOrEnd = false;



        if (arg1.date) {
            let compareDate = new Date(arg1.date.valueOf());
            compareDate.setHours(0, 0, 0, 0);

            //console.debug(this.id + " drawing date headers", this.earliestDate, compareDate);

            if (this.earliestDate === null) {
                this.earliestDate = compareDate;
                isStartOrEnd = true;
            } else if (this.earliestDate.valueOf() > compareDate.valueOf()) {
                this.earliestDate = compareDate;
            }

            if (this.earliestDate.valueOf() == compareDate.valueOf()) {
                isStartOrEnd = true;
            }

            if (this.latestDate === null) {
                this.latestDate = arg1.date;
                this.latestDate.setHours(0, 0, 0, 0);
            } else if (this.latestDate < arg1.date) {
                this.latestDate = arg1.date;
                this.latestDate.setHours(0, 0, 0, 0);
            }

            /*if (this.latestDate.toLocaleDateString() == data.date.toLocaleDateString()) {
                isStartOrEnd = true;
            }*/





            //const stringDate = ('0' + data.date.getDate()).slice(-2) + '.' + ('0' + (data.date.getMonth() + 1)).slice(-2) + '.'/* + data.date.getFullYear()*/;
            let stringDate = this.dateTimeToString(arg1.date, "EEE dd.MM.yy");
            let schedule = this.scheduleObject as SyncFusionCalendarTypes.Syncfusion_ScheduleObject;
            if (this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.timelineOverview) {
                stringDate = this.dateTimeToString(arg1.date, "EEE dd.MM."); // kein Platz fürs Jahr im Monatsview
            }
            let container = this.UiModder.domConstruct.create("div", {
                "className": "date-text",
                "innerHTML": stringDate
            });

            let infoContainer = this._createDateInfoContainer(container, arg1.date);

            let monthLabel = this.dateTimeToString(arg1.date, "MMM yyyy");
            let monthLabelNode = this.UiModder.domConstruct.create("span", {
                className: "monthLabel",
                innerHTML: monthLabel
            }, infoContainer);

            if (arg1.date.getDate() == 1 ||
                (this.getCurrentViewMode() != WebcalendarTypes.WebCalendar_ViewModes.week &&
                    this.getCurrentViewMode() != WebcalendarTypes.WebCalendar_ViewModes.threeDays &&
                    arg1.date.getDate() == 15) ||
                isStartOrEnd == true ||
                (this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.day)) {
                this.UiModder.domClass.add(monthLabelNode, "visible");

                this.UiModder.domClass.toggle(container, "firstInMonth", arg1.date.getDate() == 1);
            }


            this.UiModder.domClass.toggle(container, "date-weekend", arg1.date.getDay() == 0 || arg1.date.getDay() == 6); // wochenende
            this.UiModder.domClass.toggle(container, "today", arg1.date.toLocaleDateString() == (new Date()).toLocaleDateString()); // heute

            return container.outerHTML;

        }
    }
    private _getMonthHeaderTemplate(arg1: { date: Date, type: string }, arg2: Object, arg3: string) {
        //console.debug(this.id + "_getMonthHeaderTemplate", arg1, arg2, arg3);
        return this.dateToString(arg1.date, "MMMM yyyy");
        return "<span>MonthHeader</span>";
    }
    private _getResourceHeaderTemplate(arg1, arg2: Object, arg3: string) {
        console.debug(this.id + "_getResourceHeaderTemplate", arg1, arg2, arg3);

        return "<span>ResourceHeader</span>";
    }

    async initScheduler(container: HTMLElement) {
        if (!window.calendarTimezone) {
            window.calendarTimezone = "CET"; // default wert falls calendarTimezone in der AppSettings.config fehlt
        }

        let currentLocale = window.navigator.languages[0];  // firefox gibt de zurück, andere teilweise de-DE... wir brauchen Format de-DE oder en-EN! hmpf

        if (window.ej.base.registerLicense) {
            if (SyncfusionHelper.loadLicense(this.getModule("Webcalendar")["license"]) == false) {
                this.showToast(this.translations["SyncfusionLicenseError"], "fas fa-bug");
            }
            if (SyncfusionHelper.loadLanguage() == false) {
                console.error("syncfusionhelper: can't load translation");
                this.showToast("Syncfusion: can't load translation", "fas fa-bug");
            }
        }

        let calendarHeightCss: string = "calc(100vh - var(--marginTopbar))";
        if (document.body.classList.contains("msTeamsTabMode")) {
            calendarHeightCss = "90vh";
        }
        this.scheduleObject = new window.ej.schedule.Schedule({
            cssClass: 'calendarMainContainer',
            height: calendarHeightCss, // brauchma, weil sonst Monatsansicht etc nicht die volle Höhe verwendet
            //height: 'calc(100vh - 67px)',

            // ----------------
            // readonly ist eigentlich false, aber es soll true sein damit das onCllClick event gefeuert wird!
            readonly: false,
            allowDragAndDrop: false, // resize/DnD abschalten
            allowResizing: false, // resize/DnD abschalten
            // -------------------------

            //allowMultiCellSelection: true,
            allowKeyboardInteraction: false,

            allowSwiping: false,

            firstDayOfWeek: 1, // Montag! 0 = Sonntag
            firstMonthOfYear: 3,
            monthsCount: 3,
            rowAutoHeight: true,
            currentView: this.currentView,
            views: [
                { option: 'Day', interval: 1 },
                { option: 'Day', interval: 3 },
                { option: 'Week', interval: 1 },
                { option: 'Week', interval: 2 },
                { option: 'TimelineWeek', interval: 4 },
                { option: 'Month', interval: 1 },
                { option: 'Month', interval: 3 },
                { option: 'Year', interval: 1 },
                { option: 'TimelineDay', interval: 1 },
                { option: 'TimelineDay', interval: 3 },
                { option: 'TimelineDay', interval: 7, allowVirtualScrolling: false },
                { option: 'TimelineWeek', interval: 1 },
                { option: 'TimelineWeek', interval: 2 }, // the scheduler is performing a lot worse with virtual scrolling, than without
                { option: 'TimelineWeek', interval: 6 }, // the scheduler is performing a lot worse with virtual scrolling, than without
                { option: 'TimelineMonth', interval: 1 }, // , allowVirtualScrolling: true
                { option: 'TimelineDay', interval: 90, allowVirtualScrolling: true },
                { option: 'TimelineMonth', interval: 4, allowVirtualScrolling: true },
                { option: 'TimelineMonth', interval: 2, allowVirtualScrolling: true },
                { option: 'TimelineWeek', interval: 9, allowVirtualScrolling: true },
                { option: 'TimelineYear', interval: 1, firstDayOfWeek: 1 }//, allowVirtualScrolling: true }
            ],
            timeFormat: 'HH:mm',
            timezone: window.calendarTimezone,
            // dateRangeTemplate: lang.hitch(this, this._getDateRangeTemplate), //`??
            //headerIndentTemplate: lang.hitch(this, this._getHeaderIndentTemplate), // zelle oben Links im "toten Eck"
            //cellHeaderTemplate: lang.hitch(this, this._getMonthCellHeaderTemplate), // Nummerierung der Tage in Monatsansicht und Minimonate bei Jahresansicht
            dayHeaderTemplate: lang.hitch(this, this._getDayHeaderTemplate), // Einzeltag-Kopfzeile in Minimonaten bei Jahresansicht (Mo-So)
            dateHeaderTemplate: lang.hitch(this, this._getDateHeaderTemplate), // Wochentag-Überschrift (Montag-Sonntag) bei Wochenansicht //'${getDateHeaderText(data)}',
            monthHeaderTemplate: lang.hitch(this, this._getMonthHeaderTemplate), // Monatsbeschriftung bei Jahresansicht
            //resourceHeaderTemplate: lang.hitch(this, this._getResourceHeaderTemplate), // Ressource(-ngruppe) bei Timeline (Y-Achse)
            timeScale_default: {
                enable: true,
                interval: 60,
                slotCount: 2
            },
            timeScale: {
                enable: true,
                interval: 60,
                slotCount: 2
            },
            group: {
                // byGroupID: true ist nötig damit SyncFusion die Resources strikt anhand
                // ihrer groupId der jeweils richtigen ResourceGroup zuordnet.
                // Mit false zeigt SyncFusion alle child resources unter jeder parent group
                // (= cross-contamination zwischen Top-Groups bei mehreren aktiven Resources).
                // Damit Events die zu mehreren ResourceGroups gehören trotzdem in jeder
                // davon erscheinen, dupliziert _createEventsFromCalendarItemData den Event
                // pro matchender (Resource, ResourceGroup)-Tupel.
                byGroupID: true,
                resources: this.groups,
                enableCompactView: this.hasFeature("Webcalendar/EnableCompactView")
            },
            resources: [
                {
                    field: 'GroupId',
                    title: this.translate("WebCalendar_ResourceLabel__Groups"),
                    name: "Groups",
                    allowMultiple: true,
                    textField: 'text',
                    idField: 'id'
                },
                {
                    field: 'ResourceId',
                    title: this.translate("WebCalendar_ResourceLabel__Rooms"),
                    name: 'Resources',
                    allowMultiple: true,
                    dataSource: this.resources,
                    textField: 'label',
                    idField: 'id',
                    groupIDField: 'groupId'
                },
                {
                    field: 'ResourceGroupId',
                    title: "ResourceGroups --- label???",
                    name: 'ResourceGroups',
                    dataSource: this.resourceGroups,
                    textField: 'label',
                    idField: 'id'
                }
            ],
            eventSettings: {
                dataSource: this.events,
                allowEditing: false,
                enableTooltip: true, // wird bei onMouseEnter anhand von this.enableToolTip entschieden ob wir den tooltip anzeigen oder nicht
                tooltipTemplate: '<div class="sfc_tooltip"></div>' //tooltip wird ueber event hook beschrieben
            },
            dataBound: lang.hitch(this, this._onDataBound),
            //locale: currentLocale ? currentLocale : "de-DE",
            renderCell: lang.hitch(this, this._onCellRender),
            eventRendered: lang.hitch(this, this._onEventRenderd),

            popupOpen: (args) => { // QuickInfo Popup insted of the generic dialog? -> https://ej2.syncfusion.com/javascript/documentation/schedule/how-to/quick-info-template/
                //console.log("popupOpen", args);

                args.cancel = true; // REMOVE IF SCHEDULERS OWN POPUP NEEDED
                if ((args.type === 'QuickInfo' || args.type === 'ViewEventInfo') && args.target.classList.contains('e-appointment')) {

                    if (args.data.Object?.Classname == "__external__") {
                        return; // kein popup für externe daten
                    }

                    if (typeof (this.itemClickFunction) === 'undefined') {
                        this.setDefaultItemClickFunction();
                    }
                    this.itemClickFunction(args.data.Object);
                }
            },

            cellClick: lang.hitch(this, this._onCellClick),
            navigating: lang.hitch(this, this._onCalendarNavigating),
            actionBegin: lang.hitch(this, this._onActionBegin),
            actionComplete: lang.hitch(this, this._onActionComplete),


        });

        this.scheduleObject.appendTo(container);
        this.syncFusionContainer = container;
    }

    private monkeyPatch_onAfterRenderTooltip: Function = null;
    private _onDataBound(...args) {
        this.emit("DataBound", args);

        /*
        dynamic tooltip event hook

        es gaebe schon scheduleObject.eventTooltip.tooltipObj.afterOpen als event hook
        nur die coolen menschen von syncfusion callen eigenen event hooks nicht...
        deshalb koenne  wir hier tooltipAfterRender monkey patchen :(

        und dadurch das die funktion in der life-time bei dataBound wieder ueberschrieben wird, muessen wir einfach bei jedem data bound monkey patchen...
        */
        if (typeof this.scheduleObject.eventTooltip?.tooltipObj == 'undefined') {
            console.error("cannot hook scheduleObject.eventTooltip.tooltipObj"); //syncfusion lib update???
            return;
        }

        if (this.monkeyPatch_onAfterRenderTooltip == null) {
            this.monkeyPatch_onAfterRenderTooltip = this.scheduleObject.eventTooltip.tooltipObj.tooltipAfterRender;
        }
        this.scheduleObject.eventTooltip.tooltipObj.tooltipAfterRender = lang.hitch(this, this._onAfterRender_TooltipHook);
    }

    private _setTooltipContent(newContent: TooltipData, ctrlObj: Object) {
        let node = (ctrlObj["content"] as HTMLDivElement);
        if (typeof node != 'undefined') {
            if (node instanceof HTMLDivElement) {
                if (document.contains(node)) {
                    let tooltipContainer = this.UiModder.domConstruct.create('div', {
                        className: "itemTooltip"
                    });

                    let itemClone = ctrlObj["itemClone"] as HTMLElement;
                    if (itemClone) {
                        this.UiModder.domConstruct.place(itemClone, tooltipContainer);
                    }

                    let tooltipContent = this.UiModder.domConstruct.create('div', {
                        className: "content"
                    }, tooltipContainer);

                    if (typeof newContent != 'undefined') {
                        if (typeof (newContent) == "object") {
                            let data = newContent as TooltipData;
                            tooltipContent.innerHTML = data.tooltipContent ? data.tooltipContent : "";
                            if (data.hasContent === false) {
                                this.UiModder.domClass.add(tooltipContainer, "noContent");
                            }
                            this.hideNode(tooltipContent, !data.tooltipContent);
                        }
                        if (newContent instanceof HTMLElement) {
                            tooltipContent.appendChild(newContent as HTMLElement);
                        }
                        if (typeof newContent == 'string') {
                            tooltipContent.innerHTML = newContent as string;
                        }
                        if (newContent == null) {
                            tooltipContent.innerHTML = "";
                            this.hideNode(tooltipContent);
                        }
                    }

                    node.innerHTML = "";
                    node.appendChild(tooltipContainer);
                }
            }
        }
    }
    private _onAfterRender_TooltipHook(target: HTMLDivElement,
        e: MouseEvent,
        showAnimation: { effect: 'FadeIn' | string, duration: number, delay: number },
        ctrlObj: Object) {
        let entityID: string = target.getAttribute("data-entity-id")
        let entityClassName: string = target.getAttribute("data-entity-classname");

        //console.debug("_onAfterRender_TooltipHook", target, e);

        if (this.enableToolTip) {
            const secondParent = (ctrlObj["content"] as HTMLDivElement)?.parentElement?.parentElement;
            if (secondParent) {
                secondParent.classList.remove("w3-hide");
            } else {
                console.warn("syncfusion calendar: cannot access tooltip parent, did the sf-lib version change?");
            }


            let tooltipContainer = document.createElement('div');
            this.UiModder.domClass.add(tooltipContainer, "itemTooltip loading");

            if (target) {
                try {
                    let clone = lang.clone(target);
                    this.UiModder.domConstruct.place(clone, tooltipContainer);
                    this.UiModder.domClass.add(clone, "appointmentCopy");
                    this.UiModder.domStyle.set(clone, "height", "");
                    this.UiModder.domStyle.set(clone, "width", "");

                    let event = this.getEventById(entityID);
                    if (event) {
                        let start: Date = null;

                        if (event.StartTime) {
                            start = new Date(event.StartTime);
                        }
                        if (start) {
                            let row = this.UiModder.domConstruct.create("div", {
                                className: "tooltipDateRow"
                            }, clone, "first");
                            this.UiModder.domConstruct.create("div", {
                                className: "tooltipStartDate",
                                innerHTML: event.IsAllDay ? DateHelpers.dateToString(start) : DateHelpers.dateTimeToString(start)
                            }, row);

                            if (event.EndTime) {
                                let end = new Date(event.EndTime);
                                if (DateHelpers.IsSameDay(start, end) && event.IsAllDay) {
                                } else {
                                    let str = "";
                                    if (DateHelpers.IsSameDay(start, end)) {
                                        if (event.IsAllDay) {
                                            // nix tun - Start alleine reicht
                                        } else {
                                            str = end.toLocaleTimeString(undefined, { timeStyle: "short" });
                                        }
                                    } else {
                                        if (event.IsAllDay) {
                                            str = end.toLocaleDateString();
                                        } else {
                                            str = DateHelpers.dateTimeToString(end);
                                        }
                                    }

                                    if (str) {
                                        this.UiModder.domConstruct.create("div", {
                                            className: "tooltipEndDate",
                                            innerHTML: str
                                        }, row);
                                    }
                                }
                            }
                        }
                    }
                    ctrlObj["itemClone"] = clone;

                } catch (ex) {

                }
            }


            (ctrlObj["content"] as HTMLDivElement).innerHTML = "";
            (ctrlObj["content"] as HTMLDivElement).appendChild(tooltipContainer);

            //um request zu sparen, werden results ge-cached...
            let key = entityClassName + "-" + entityID;
            let bFoundCache = false;
            const maxCacheTime = 120; // in sekunden

            if (Object.keys(this.tooltipCache).includes(key) && (maxCacheTime > 0)) {
                let data: TooltipData = this.tooltipCache[key].content;
                let content = data.tooltipContent;
                let timeAdded: Date = this.tooltipCache[key].timeAdded;
                if ((timeAdded instanceof Date) == false) {
                    timeAdded = new Date(timeAdded as any as string);
                }
                let diffTime = new Date().getTime() - timeAdded.getTime();
                diffTime = diffTime / 1000; // in seconds
                diffTime = Math.abs(diffTime);
                diffTime = Math.floor(diffTime);
                if (diffTime < maxCacheTime) {
                    this._setTooltipContent(data, ctrlObj);
                    bFoundCache = true;
                }
            }
            //cache nicht verwenden/nicht vorhanden, fetchen

            //tooltip content laden
            if (!bFoundCache) {
                if (this._tooltipFetchHandle) clearTimeout(this._tooltipFetchHandle);
                this._tooltipFetchHandle = setTimeout(lang.hitch(this, this.fetchToolTip, tooltipContainer, entityClassName, entityID, ctrlObj), 500);
            }
        } else {
            let secondParent = (ctrlObj["content"] as HTMLDivElement).parentElement?.parentElement;
            if (secondParent) {
                secondParent.classList.add("w3-hide");
            } else {
                console.warn("syncfusion calendar: cannot access tooltip parent, did the sf-lib version change?");
            }
            //um sf nicht zu bricken, leiten wir den fn call trozdem weiter
        }

        let fnCallResult: any = this.monkeyPatch_onAfterRenderTooltip.apply(this.scheduleObject.eventTooltip.tooltipObj, [target, e, showAnimation, ctrlObj]);
        return fnCallResult;
    }
    private _tooltipFetchHandle: any = null;
    private tooltipCache: Record<string, { content: TooltipData, timeAdded: Date }> = {};
    public tooltipAdditionalOptions: Object = {};
    private tooltipQueue: ExtraHelpers.AsyncOperationQueue;
    private async fetchToolTip(tooltipContainer: HTMLElement, entityClassname: string, appointmentID: string, ctrlObject) {
        if (!tooltipContainer || tooltipContainer.isConnected != true || !tooltipContainer.parentElement) {
            return;
        }



        let loadingContainer = this.UiModder.domConstruct.create('div', {
            className: "flex_row_center flex_gapSmall nowrap content"
        }, tooltipContainer);

        let loadingLabel = this.UiModder.domConstruct.create('span', {
            innerHTML: TranslationHelpers.tryTranslate('WebCalendar_Tooltip_LoadingTxt'),
            className: "loadingText"
        }, loadingContainer);

        HtmlHelpers.createFontawesomeIcon("fas fa-circle-notch fa-spin w3-large loadingIcon", null, loadingContainer, "first");


        let content: TooltipData;

        if (typeof this.tooltipFetchDataFunction == 'function') {
            content = await this.tooltipQueue.enqueue(this.tooltipFetchDataFunction as any, true);
            //content = await (this.tooltipFetchDataFunction as Function)();
        } else if (typeof this.tooltipFetchDataFunction == 'string') {
            if (typeof this.tooltipAdditionalOptions != 'object') {
                this.tooltipAdditionalOptions = {};
            }

            let callfunctionAsync = async () => {
                return new Promise((resolve, reject) => {
                    this.RequestManager.callfunction(
                        this.tooltipFetchDataFunction as string,
                        Object.assign(this.tooltipAdditionalOptions, {
                            id: appointmentID,
                            classname: entityClassname
                        }),
                        (successResult: any) => {
                            resolve(successResult);
                        },
                        (err) => {
                            console.error(err);
                            this.showToast(err.Message, "fas fa-exclamation-triangle");
                            reject(err);
                        }
                    );
                });
            }; //refactor als fn falls wir spaeter ThreadSafeQueue verwenden wollen

            // wir verwnden einen queue damit, wenn der user ueber 10 termine hovered nicht den server mit 50 request zumuellt...
            // priority=true damit das element das gerade hover hat, als erstes den display string bekommt.
            let contentPromise: Promise<string | TooltipData> = this.tooltipQueue.enqueue(callfunctionAsync, true);

            try {
                let res = await contentPromise;
                let tooltipResult: TooltipData = res as any;
                if (typeof res == 'string') {
                    tooltipResult = JSON.parse(res);
                }
                let obk: Array<string> = Object.keys(res as Object);


                content = tooltipResult;

            } catch {
                let fakeData: TooltipData = { hasContent: false, tooltipContent: TranslationHelpers.translate("General_Error") }
                content = fakeData;
            }
        } else {
            if (this.hasFeature("webcalendar/enableLocalTooltip")) {
                content = { hasContent: false, tooltipContent: "" };
            } else {

                console.error("invalid con");
                throw "invalid configuration for tooltipFetchDataFunction";
            }
        }
        if (typeof content != 'undefined') {
            if (typeof content == 'object') {
                let key = entityClassname + "-" + appointmentID;

                this.tooltipCache[key] = {
                    content: (content as TooltipData),
                    timeAdded: new Date()
                };
            } else {
                //this.tooltipCache[key] = {
                //    content: content.outerHTML,
                //    hasContent: true,
                //    timeAdded: new Date()
                //};
            }
            //return content;
            this._setTooltipContent(content, ctrlObject);
        } else {
            console.warn("invalid tooltip response", content, "for entity", entityClassname, appointmentID);
        }


    }
    private tooltip_ClearCache() {
        if (this.tooltipQueue.isBusy()) {
            this.tooltipQueue.clear();
        }
        this.tooltipCache = {};
    }

    private nodesToFix: Array<HTMLElement>;

    private _afterTableRenderedTimeout;
    private _afterTableRendered() {

    }

    private _onCellRender(args: { date: Date, elementType: string, element: HTMLElement, groupIndex: number }) {

        //console.debug("_onCellRender", args.elementType, args); // unbedingt wieder ausschalten wenn nicht mehr nötig!

        // E2E: sprach-/TZ-neutrales ISO-cy an den Tageszellen (Monats-/Jahresansicht) fuer Testselektion.
        // Nur an Tages-Mitternachtszellen -> genau EINE calDay:<YYYY-MM-DD> pro Tag (keine Dubletten in
        // Wochen-/Tagesansicht mit Zeitslots). Datum aus args.date (lokale Anzeige -> kein TZ-Problem).
        if (args.date && args.element && args.element.classList && args.element.classList.contains("e-work-cells")
            && args.date.getHours() === 0 && args.date.getMinutes() === 0 && args.date.getSeconds() === 0) {
            const _p = (n: number) => (n < 10 ? "0" + n : "" + n);
            const _iso = args.date.getFullYear() + "-" + _p(args.date.getMonth() + 1) + "-" + _p(args.date.getDate());
            args.element.setAttribute("data-cy", "calDay:" + _iso);
        }

        if (args.elementType == "monthCells") {
            // Monatsansicht Zellenkopf
            // am Monatsersten das Label korrigieren - ist sonst immer englisch
            if (args.elementType === "monthCells") {
                // am Monatsersten das Label korrigieren - ist sonst immer englisch
                let cellDate = args.date;
                let labelNodes = args.element.querySelectorAll(".e-date-header");
                if (cellDate && cellDate.getDate && cellDate.getDate() == 1) {
                    this.UiModder.domClass.add(args.element, "firstInMonth");

                    for (let i = 0; i < labelNodes.length; i++) {
                        let labelnode = labelNodes[i] as HTMLElement;
                        labelnode.innerHTML = this.dateTimeToString(cellDate, "dd. MMMM");
                        break;
                    }
                }

                if (labelNodes) this._createDateInfoContainer(labelNodes[0] as HTMLElement, cellDate);
            }
        }

        if (args.elementType == "resourceGroupCells") {
            //console.debug("_onCellRender", args.elementType, args, this.resourceGroups);
            // RessourcenGRUPPEN-Zeilen sind nicht bearbeitbar, bekommen aber natürlich auch ihre Zellen.
            // über den Groupindex bekommen wir die Ressourcengruppe mit Farbe
            // ABER: der groupIndex zählt alle Ressourcen durch.
            // d.h. wenn es Gruppe 2 im Array ist (= Index 1) und die Gruppe 1 davor hatte 12 Ressourcen,
            // dann finden wir die Gruppe bei Index 0 + 12
            let targetIndex = args.groupIndex;
            let lineIndexTotal = 0;
            for (let i = 0; i < this.resourceGroups.length; i++) {
                let grp = this.resourceGroups[i];
                // den eigenen Arrayindex dazuzählen:
                lineIndexTotal += i; // beim ersten Durchlauf bleibt das bei 0 - das ist richtig so!
                if (targetIndex == lineIndexTotal) {
                    if (grp.colorationBG) args.element.style.setProperty("--colorBG", grp.colorationBG);
                    if (grp.colorationTXT) args.element.style.setProperty("--colorTXT", grp.colorationTXT);
                    break;
                }
                // wenn noch nicht erreicht, dann die eigene Anzahl an Child-Lines dazuzählen:
                lineIndexTotal += grp.Count;
            }
        }

        if (args.elementType === "monthDay") {
            if (this.earliestDate === null) {
                this.earliestDate = args.date;
                this.earliestDate.setHours(0, 0, 0, 0);
            } else if (this.earliestDate > args.date) {
                this.earliestDate = args.date;
                this.earliestDate.setHours(0, 0, 0, 0);
            }
            if (this.latestDate === null) {
                this.latestDate = args.date;
                this.latestDate.setHours(0, 0, 0, 0);
            } else if (this.latestDate < args.date) {
                this.latestDate = args.date;
                this.latestDate.setHours(0, 0, 0, 0);
            }
            /**
             * For some reason, the dateHeaderTemplate is not working in the month view only in weeks or days.
             * */
            this._replaceWeekdayLabels(args.element);
        }

        //if (args.elementType == "headerCells") {
        //    let currentView = this.getCurrentViewMode();
        //    console.debug(this.id + " cellRender headerCells", args, currentView);
        //    // Monatsüberschrift in den Minimonaten der Jahresansicht
        //    if (currentView == WebcalendarTypes.WebCalendar_ViewModes.year) {
        //        if (args.date) {
        //            try {
        //                let now = new Date();
        //                if (args.date.getMonth() == now.getMonth() && args.date.getFullYear() == now.getFullYear()) {
        //                    this.UiModder.domClass.add(args.element, "currentMonth");
        //                }
        //            } catch (ex) {
        //                console.warn("cellRender headerCells", ex);
        //            }
        //        }
        //    }
        //}

        //}

        //if (args.elementType === "workCells") {
        //    let targetDate = args.date;
        //    let currentView = this.getCurrentViewMode();
        //    if (currentView == WebcalendarTypes.WebCalendar_ViewModes.year) {
        //        // Klick auf den Tag in Jahresansicht soll zu Tagesansicht oder sonst wie zum Ziel führen
        //        args.element.onclick = lang.hitch(this, this._onCellClick, args);
        //    }
        //}

        if (args.elementType === "alldayCells" || args.elementType === "workCells" || args.elementType === "monthCells") {
            switch (args.date.getDay()) {
                case 0:
                case 6:
                    //this.UiModder.domStyle.set(args.element, "backgroundColor", "var(--weekendBG, var(--complimentaryThemeL5))");// "rgb(222, 253, 249)";
                    this.UiModder.domClass.add(args.element, "weekend");
                    break;
                default:
                    //args.element.style.background = "white";
                    break;
            }

            let currentView = this.getCurrentViewMode();

            if (currentView == WebcalendarTypes.WebCalendar_ViewModes.timelineYear) {
                let dateNode = args.element.querySelector(".e-date-header");
                this._createDateInfoContainer(dateNode as HTMLElement, args.date);
            }

            this.UiModder.domClass.toggle(args.element, "today", args.date.toLocaleDateString() == (new Date()).toLocaleDateString()); // heute
        }
        if (args.elementType === "dateHeader") {

            //    if (this.scheduleObject.currentView == SyncfusionCalendar_ViewModes.TimelineMonth) {
            //        this.UiModder.domStyle.set(args.element, "width", "40px");
            //    }
        }
        if (args.elementType == "resourceGroupCells") {

        } if (args.elementType == "resourceHeader") {
            // Ressourcen-Zellen (Räume) und Gruppierungen!
            //console.debug("render resourceHeader", args, this.resources);

            let groupIndex = args.groupIndex;
            let node = args.element as HTMLElement;
            try {
                if (this.isTimeLineMode()) {

                    // PROBLEM: manche dieser Zellen sind nicht in this.resources, sondern in this.resourceGroups!!
                    // der groupIndex zählt aber "flach" über alle drüber
                    // wir erkennen nur über die Klasse der Node, ob es eine Gruppe oder eine Resource ist
                    // also eigentlich müssen wir jetzt über alle Gruppen und Resourcen drüberzählen und uns einen counter selber machen
                    let totalCounter = 0;
                    let grpIndex = -1;
                    let resIndex = -1;
                    let bTargetIsGroup = node.classList.contains("e-parent-node");

                    if (this.resourceGroups.length) {
                        for (let a = 0; a < this.resourceGroups.length; a++) {
                            let grp = this.resourceGroups[a];

                            // wenn zb groupIndex 0 gefragt ist: im ersten durchlauf der ersten Gruppe sind wir noch auf 0.
                            if (groupIndex == totalCounter && bTargetIsGroup) {
                                grpIndex = a;
                                break;
                            }

                            // wenn nicht, dann bei den Gruppen weiterzählen
                            for (let b = 0; b < this.resources.length; b++) {
                                let res = this.resources[b];
                                if (res.groupId == grp.id/* && res.descriptorId == grp.descriptorId*/) {
                                    totalCounter++;

                                    if (totalCounter == groupIndex && !bTargetIsGroup) {
                                        resIndex = b;
                                        break;
                                    }
                                }
                            }

                            totalCounter++;
                        }
                    } else {
                        // keine Gruppen? dann sowieso flach.
                        resIndex = groupIndex;
                    }


                    let targetResource: WebcalendarTypes.SyncfusionCalendarResource = null;
                    if (resIndex != -1) targetResource = this.resources[resIndex];
                    if (grpIndex != -1) targetResource = this.resourceGroups[grpIndex];

                    if (targetResource) {
                        //console.debug("found resource to color", targetResource, args);

                        node.setAttribute("data-resource-id", targetResource.id);

                        if (targetResource.groupId) {
                            node.setAttribute("data-group-id", targetResource.groupId);
                        }

                        targetResource.node = node;

                        if (targetResource.colorationBG) {
                            node.style.setProperty("--colorBG", targetResource.colorationBG);
                        }
                        if (targetResource.colorationTXT) {
                            node.style.setProperty("--colorTXT", targetResource.colorationTXT);
                        }

                        if (targetResource)

                            if (this._resourceClickFct) {
                                on(node, "click", lang.hitch(this, this._resourceClickFct, targetResource));
                                this.UiModder.domClass.add(node, "clickable");
                            }
                    }

                    else {
                        console.warn("cell renderer found no target resource data for coloration", args);
                    }
                } else {
                    let group = this.allGroups[groupIndex];
                    if (group) {
                        if (node.firstElementChild.innerHTML == group.id) {
                            node.firstElementChild.innerHTML = group.text;
                        }
                    }
                }
            } catch (ex) {
                console.error("cell renderer error when trying to color node", args, ex);
            }
        }

        if (this._afterTableRenderedTimeout) {
            clearTimeout(this._afterTableRenderedTimeout);
        }

        this._afterTableRenderedTimeout = setTimeout(lang.hitch(this, this._afterTableRendered), 100);
    }

    private _replaceWeekdayLabels(labelnode: HTMLElement) {
        if (!labelnode || !labelnode.innerText) return;

        switch (labelnode.innerText) {
            case "Sunday":
            case "Sun":
                labelnode.classList.add("date-weekend");
                labelnode.innerText = this.translate("General_Sunday");
                break;
            case "Monday":
            case "Mon":
                labelnode.innerText = this.translate("General_Monday");
                break;
            case "Tuesday":
            case "Tue":
                labelnode.innerText = this.translate("General_Tuesday");
                break;
            case "Wednesday":
            case "Wed":
                labelnode.innerText = this.translate("General_Wednesday");
                break;
            case "Thursday":
            case "Thu":
                labelnode.innerText = this.translate("General_Thursday");
                break;
            case "Friday":
            case "Fri":
                labelnode.innerText = this.translate("General_Friday");
                break;
            case "Saturday":
            case "Sat":
                labelnode.classList.add("date-weekend");
                labelnode.innerText = this.translate("General_Saturday");
                break;
            default:
                break;
        }
    }

    scrollToFirstEvent(filteredItems?: Array<any>) {

        let items = []
        if (filteredItems) items = filteredItems;
        else items = this.getItemNodes();

        //console.debug(this.id + " scrollToFirstEvent", items, this.getCurrentViewMode());
        if (items && items.length) {
            try {
                //items = items.filter(function (entry) { return entry.event.IsAllDay != true; })
                if (this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.month) {
                    items.sort(function (a, b) {
                        let dateA = new Date(a.event.StartTime);
                        let dateB = new Date(b.event.StartTime);
                        return dateA.valueOf() - dateB.valueOf();
                    })

                } else {
                    items.sort(function (a, b) {
                        let dateA = new Date(a.event.StartTime);
                        let dateB = new Date(b.event.StartTime);
                        return dateA.getHours() - dateB.getHours();
                    })
                }


                for (let item of items) {
                    if (item.node.className.indexOf("e-all-day-appointment") == -1) {
                        //console.debug(this.id + "scrolling to this event:", item);
                        item.node.scrollIntoView();
                        break;
                    }
                }
            } catch (ex) {
                console.warn(this.id + " scrollToFirstEvent", items, this.getCurrentViewMode(), ex);
            }
        }
    }
    getCurrentSelectedFilterIDs(subFilters?: boolean): Array<string> {
        return null; // muss von außen gesetzt werden
    }
    private _afterEventRenderedHandle: any = null;
    private _onEventsRenderFinished() {
        this._afterEventRenderedHandle = null;
        if (this.currentQuicksearchTerm) this.highlightItemsByKeyword(this.currentQuicksearchTerm);
        //console.debug(this.id + " _onEventsRenderFinished", this.scrollDate);

        //this.showEndTime(this.bShowEndTime);

        if (this._holidaysReg) {
            this._drawHolidays();
        }

        if (FeatureHelpers.hasFeature("Webcalendar/EnableDateInfoPopup")) {
            let clickableNodes = this.syncFusionContainer.querySelectorAll(".clickableDate[data-date]");
            //console.debug("clickevents attached", clickableNodes);
            try {

                for (let i = 0; i < clickableNodes.length; i++) {
                    let targetNode = clickableNodes[i];
                    let attrValue = targetNode.getAttribute("data-date");
                    let targetDate = new Date(attrValue);
                    on(targetNode, "click", lang.hitch(this, this._onClick_DateInfo, targetDate));
                }
            } catch (ex) {
                console.warn("dateinfoContainer attach clickevents failed", ex);
            }
        }


        if (this.isTimeLineMode()) {
            //this.scrollDateLocked = false;
            this.startViewportObserver();
            this.setupScrollEventListener();
            //this.emitTimelineScroll();
        } else {
            setTimeout(lang.hitch(this, this.scrollToFirstEvent), 150);
        }

        this.emit("eventsRendered");
    }
    private _onEventRenderd(args: any) {

        let calendarItem = args.data.Object as WebcalendarTypes.WebCalendarItemData_Default;
        let itemNode = args.element as HTMLElement;

        try {
            itemNode.setAttribute("data-entity-classname", calendarItem.Classname);
            itemNode.setAttribute("data-entity-id", calendarItem.id);
        } catch (ex) {

        }

        if (this._afterEventRenderedHandle != null) {
            clearTimeout(this._afterEventRenderedHandle);
        }

        this._afterEventRenderedHandle = setTimeout(lang.hitch(this, this._onEventsRenderFinished), 100);

        //console.log("eventRendered", calendarItem, itemNode);

        //  htmlTags in label erlauben
        //
        let subjectNodes = dojoQuery(".e-subject", itemNode);
        if (subjectNodes.length > 0) {
            (subjectNodes[0] as HTMLElement).innerHTML = (subjectNodes[0] as HTMLElement).innerText;
        }

        try {
            const elements = args.element.getElementsByClassName('e-time');
            if (this.getCurrentViewMode() !== WebcalendarTypes.WebCalendar_ViewModes.timelineOverview && elements?.length) {
                if (elements.length === 1) {
                    let element = elements[0] as HTMLElement;
                    let startDate = new Date(args.data.StartTime);
                    let endDate = new Date(args.data.EndTime);
                    element.innerHTML = "";
                    this.UiModder.domConstruct.create("span", {
                        className: "startTime",
                        innerHTML: this.dateTimeToString(startDate, "HH:mm")
                    }, element);
                    this.UiModder.domConstruct.create("span", {
                        className: "endTime",
                        innerHTML: '&nbsp;-&nbsp;' + this.dateTimeToString(endDate, "HH:mm")
                    }, element);

                    //    if (this.bShowEndTime) {

                    //        element.innerText = this.dateTimeToString(startDate, "HH:mm") + ' - ' + this.dateTimeToString(endDate, "HH:mm");
                    //    } else {
                    //        element.innerText = this.dateTimeToString(startDate, "HH:mm")
                    //        //element.innerText = ('0' + args.data.StartTime.getHours()).slice(-2) + ':' + ('0' + args.data.StartTime.getMinutes()).slice(-2);
                    //    }
                } else if (elements.length == 2) {
                    // bei mehrtägigen Terminen in der Wochenansicht kann es pro item die Endzeit als Element hinten angestellt geben
                    //    if (this.bShowEndTime != true) {
                    //        this.hideNode(elements[1]);
                    //    }
                    this.UiModder.domClass.add(elements[0], "startTime");
                    this.UiModder.domClass.add(elements[1], "endTime");
                }
            }
        } catch (e) {
            console.error(e);
        }

        if ((calendarItem.bOverrideColoration == true || !calendarItem.coloration.length) && (calendarItem.Default_BackColor || calendarItem.Default_TextColor)) {
            //itemNode.style.backgroundColor = this.setOpacityHex(calendarItem.Default_BackColor, 'CC'); // 0.9 = E6 ; 0.8 = CC ; 0.7 = B3
            this._applyDefaultColor(itemNode, calendarItem);
        } else {
            for (let i = 0; i < calendarItem.coloration.length; i += 1) {
                const color = calendarItem.coloration[i];

                let colorEntry = this.getColorEntryByClass(calendarItem.Classname);

                // Matching versuchen!
                if (calendarItem.BaseClasses?.length && !colorEntry) {
                    for (let classname of calendarItem.BaseClasses) {
                        colorEntry = this.getColorEntryByClass(classname);

                        if (colorEntry) break;
                    }
                }

                if (colorEntry && color && color.ID === colorEntry.colorId) {
                    //itemNode.style.backgroundColor = this.setOpacityHex(color.BackColor, 'CC'); // 0.9 = E6 ; 0.8 = CC ; 0.7 = B3
                    itemNode.style.setProperty("--itemColorBG", this.setOpacityHex(color.BackColor, 'CC')); // 0.9 = E6 ; 0.8 = CC ; 0.7 = B3

                    if (color.TextColor) {
                        //itemNode.style.color = "#" + color.TextColor;
                        itemNode.style.setProperty("--itemColorTXT", "#" + color.TextColor);
                    } else {
                        //itemNode.style.color = this.isDarkColor(color.BackColor) ? "var(--bright)" : "var(--dark)";
                        itemNode.style.setProperty("--itemColorTXT", this.isDarkColor(color.BackColor) ? "var(--bright)" : "var(--dark)");

                    }
                    break;
                } else {
                    console.warn("event coloring failed", color, calendarItem.Classname, this.itemColorationValues);

                    itemNode.style.color = "var(--missingItemColorTxt, white)";
                    itemNode.style.backgroundColor = "var(--missingItemColorBg, #888)";
                    this.UiModder.domClass.add(itemNode, "missingColoration");
                }
            }
        }
    }

    private _applyDefaultColor(itemNode: HTMLElement, calendarItem: WebcalendarTypes.WebCalendarItemData_Default) {
        if (!itemNode || !calendarItem) return;
        if (!calendarItem.Default_BackColor && !calendarItem.Default_TextColor) {

        } else {
            this.UiModder.domClass.remove(itemNode, "missingColoration");

            itemNode.style.setProperty("--itemColorBG", this.setOpacityHex(calendarItem.Default_BackColor, 'CC')); // 0.9 = E6 ; 0.8 = CC ; 0.7 = B3
            if (calendarItem.Default_TextColor) {
                //itemNode.style.color = "#" + calendarItem.Default_TextColor;
                itemNode.style.setProperty("--itemColorTXT", "#" + calendarItem.Default_TextColor);
            } else {
                //itemNode.style.color = this.isDarkColor(calendarItem.Default_BackColor) ? "var(--bright)" : "var(--dark)";
                itemNode.style.setProperty("--itemColorTXT", this.isDarkColor(calendarItem.Default_BackColor) ? "var(--bright)" : "var(--dark)");
            }
        }
    }

    private _currentDateInfo: { dateStr: string, dateInfoWidget: MdsLax<InstanceType<typeof WebcalendarDateInfo>> } = { dateInfoWidget: null, dateStr: "xx" };

    private _onClick_DateInfo(dayDate: Date, evt: MouseEvent) {
        if (evt?.stopPropagation) evt.stopPropagation();



        let dateStr = DateHelpers.dateToLocalISOString(dayDate);
        if (this._currentDateInfo.dateStr == dateStr) {
            if (this._currentDateInfo.dateInfoWidget && !this._currentDateInfo.dateInfoWidget._destroyed) {
                return;
            }
        }
        let infoDlg = new WebcalendarDateInfo();
        infoDlg.setup({
            position: "fixed",
            node: evt.target as HTMLElement,
            targetDate: dayDate,
            evt: evt,
            activeFilterIDs: this.getCurrentSelectedFilterIDs(),
            activeSubfilterIDs: this.getCurrentSelectedFilterIDs(true)
        });

        this._currentDateInfo = { dateStr: dateStr, dateInfoWidget: infoDlg };
    }

    private getColorValueIndexByClass(classname: string): number {
        let i = -1;
        for (let entry of this.itemColorationValues) {
            i++;
            if (entry.classname == classname) return i;
        }

        return -1;
    }

    private getColorEntryByClass(classname: string): WebcalendarTypes.ColorValue {
        let i = this.getColorValueIndexByClass(classname);
        if (i == -1) return null;

        return this.itemColorationValues[i];

    }

    private getColorValueByClass(classname: string): string {
        let i = this.getColorValueIndexByClass(classname);
        if (i == -1) return null;

        return this.itemColorationValues[i].colorId;
    }

    private _onCellClick(args): void {
        //console.log("cellClick", args);
        args.cancel = true;

        let eventData: WebcalendarTypes.CellClickData_Simple = {
            //cancel: true,
            node: args.element,
            endTime: args.endTime,
            startTime: args.startTime,
            isAllDay: args.isAllDay,
            evt: args.event
            //groupIndex: args.groupIndex
        };

        if (this.isTimeLineMode()) {

            let resource = this.resources[args.groupIndex];
            eventData.resource = resource;
        }

        this.emit("calendarCellClicked", eventData);
    }

    private _onCalendarNavigating(evt: Partial<{
        action: string,
        cancel: boolean,
        previousDate: Date,
        currentDate: Date | number,
        currentView: string,
        previousView: string,
        name: string
    }>) {
        // action: "date"
        // name: "navigating"
        console.debug(this.id + " _onCalendarNavigating", evt);

        if (typeof evt.currentDate == "number") {
            this.selectedDate = new Date(evt.currentDate);
        } else {
            this.selectedDate = evt.currentDate;
        }

        if (evt.action == "view") {
            switch (evt.currentView?.toLowerCase()) {
                case WebcalendarTypes.WebCalendar_ViewTypes.year:
                    let firstDate: Date = this.selectedDate;
                    let lastDate: Date = null;
                    if (typeof (evt.currentDate) == "number") {
                        firstDate = new Date(evt.currentDate);
                    } else if (evt.currentDate) {
                        firstDate = evt.currentDate;
                    }
                    if (!firstDate) firstDate = new Date();

                    firstDate.setMonth(this.yearViewSettings.firstMonthOfYear, 1);
                    firstDate.setHours(0, 0, 0, 0);

                    lastDate = new Date(firstDate.getTime());
                    lastDate = dojoDate.add(lastDate, "month", this.yearViewSettings.monthsCount);
                    lastDate = dojoDate.add(lastDate, "day", -1);
                    lastDate.setHours(23, 59, 59, 999);

                    this.earliestDate = firstDate;
                    this.latestDate = lastDate;
                    this.emit("viewChange", { view: evt.currentView.toLowerCase(), date: firstDate });
                    break;
                case WebcalendarTypes.WebCalendar_ViewTypes.day: //"Day":
                case WebcalendarTypes.WebCalendar_ViewTypes.month: //"Month":
                case WebcalendarTypes.WebCalendar_ViewTypes.week: // "Week":
                    if (typeof (evt.currentDate) == "number") {
                        this.earliestDate = new Date(evt.currentDate);
                    } else if (evt.currentDate) {
                        this.earliestDate = evt.currentDate;
                    }
                    //this.setScheduleSelectedDate(this.earliestDate);
                    this.emit("viewChange", { view: evt.currentView.toLowerCase(), date: evt.currentDate });
                    break;
            }
        } else if (evt.action == "date") {
            // date wurde geändert (blättern)
            this.earliestDate = null;
            this.emit("calendarPageChange");
        }


    }
    private _onActionBegin(evt: { requestType: string, cancel: boolean, event: any, name: string }) {
        // action: "dateNavigate"
        // name: "actionBegin"

        //console.debug(this.id + " _onActionBegin", evt);

        this.nodesToFix = [];

        switch (evt.requestType) {
            case "dateNavigate":
                this.removeToast("webcalendarQuicksearch");
                break;

            case "toolbarItemRendering":

                break;
        }
    }

    private timelineCollapseAndExpandGroups_resetAll() {
        //clean reset von dem zeug, damit ja nix ueberbleibt
        if (!this.scheduleObject) {
            return;
        }

        const cache = (this.scheduleObject as any)["mds_timelineExpandEvCache"];
        if (typeof cache !== 'object' || cache === null || Object.keys(cache).length === 0) {
            return;
        }

        const allCurrentEvents = this.scheduleObject.getEvents();
        const eventsToSave: Record<string, any>[] = [];

        const processedEventIds = new Set<string | number>();

        for (const cacheKey in cache) {
            if (Object.prototype.hasOwnProperty.call(cache, cacheKey)) {
                const appointmentsToRestore = cache[cacheKey] ?? {};
                for (const eventId in appointmentsToRestore) {
                    if (Object.prototype.hasOwnProperty.call(appointmentsToRestore, eventId)) {
                        if (processedEventIds.has(eventId)) {
                            continue;
                        }
                        const cacheInfo = appointmentsToRestore[eventId];
                        const currentEvent = allCurrentEvents.find(e => e.Id == eventId);

                        if (currentEvent) {
                            let eventClone = (window as any).ejs.base.extend({}, currentEvent, undefined, true) as Record<string, any>;
                            eventClone[cacheInfo.childField] = cacheInfo.originalChildId;
                            eventsToSave.push(eventClone);
                            processedEventIds.add(currentEvent.Id);
                        }
                    }
                }
            }
        }
        (this.scheduleObject as any)["mds_timelineExpandEvCache"] = {};
        if (eventsToSave.length > 0) {
            this.scheduleObject.saveEvent(eventsToSave);
        }
    }

    public clearEventsAndRender() {
        //aus performance gruenden, cleartn den calendar intern und rendered leer
        //wird (oder sollte) immer getriggered bei view und page change
        this.events = [] as any;
        this.scheduleObject.eventSettings.dataSource = this.events;
        this.scheduleObject.dataBind();
    }
    private handle_timelineCollapseAndExpandGroups(actionEventArgs: { requestType: string, cancel: boolean, name: string, groupIndex?: number }) {
        // sind wir in timeline mode?
        if ((this.scheduleObject.currentView ?? "").toLowerCase().startsWith("timeline") == false) {
            return;
        }
        let eventType: string = actionEventArgs?.requestType ?? "";
        // nur diese zwei event handlen
        if (eventType !== "resourceCollapsed" && eventType !== "resourceExpanded") {
            return;
        }

        const groupIndex: number = actionEventArgs.groupIndex ?? -1;
        if (groupIndex === -1) {
            return;
        }

        // resource config dynamisch abfragen, weil waere ja zu einfach wenn man alles was man braucht im event kriegen wuerde
        const groupResourceNames = this.scheduleObject.group.resources;
        if (!groupResourceNames || groupResourceNames.length < 2) {
            console.warn("This function requires at least two levels of resource grouping.");
            return;
        }
        const parentResourceConfig = this.scheduleObject.resources.find(r => r.name === groupResourceNames[0]);
        const childResourceConfig = this.scheduleObject.resources.find(r => r.name === groupResourceNames[1]);
        if (!parentResourceConfig || !childResourceConfig || !childResourceConfig.idField || !childResourceConfig.groupIDField) {
            console.error("Could not find resource configurations or required fields (idField, groupIDField).");
            return;
        }
        const parentEventField: string = parentResourceConfig.field as string;
        const parentIdField: string = parentResourceConfig.idField as string;
        const childEventField: string = childResourceConfig.field as string;
        const childIdField: string = childResourceConfig.idField;
        const childGroupIdField: string = childResourceConfig.groupIDField;

        // cache initialisieren
        if (typeof (this.scheduleObject as any)["mds_timelineExpandEvCache"] !== 'object') {
            (this.scheduleObject as any)["mds_timelineExpandEvCache"] = {};
        }

        const isExpanded: boolean = actionEventArgs.requestType == "resourceExpanded";
        const eventsToSave: Record<string, any>[] = [];

        // haupt logic: expand + collapse handlen
        if (isExpanded) {
            // expand - gruppe wurde ausgeklappt: wir restoren event group id's aus cache
            const cacheKey = "group_" + groupIndex;
            const appointmentsToRestore = (this.scheduleObject as any)["mds_timelineExpandEvCache"][cacheKey] ?? {};

            if (Object.keys(appointmentsToRestore).length < 1) {
                return; // nix zu tun
            }

            const allCurrentEvents = this.scheduleObject.getEvents();

            for (const eventId in appointmentsToRestore) {
                const cacheInfo = appointmentsToRestore[eventId];
                // aktuelle version vom event finden (weil koennte ja in der zwischenzeit bearbeitet worden sein)
                const currentEvent = allCurrentEvents.find(e => e.Id == eventId);
                if (currentEvent) {
                    let eventClone = (window as any).ejs.base.extend({}, currentEvent, undefined, true) as Record<string, any>;
                    //nur restoren wenn in der zwischenzeit keine andere category gesetzt wurde
                    if (typeof eventClone[cacheInfo.childField] == 'undefined') {
                        // group id restore
                        eventClone[cacheInfo.childField] = cacheInfo.originalChildId;
                        eventsToSave.push(eventClone);
                    }
                }
            }
            // cache loeschen
            delete (this.scheduleObject as any)["mds_timelineExpandEvCache"][cacheKey];

        } else {
            // gruppe wurde zusammengeklappt: wir setzen die gruppen id auf undefined damit diese immer noch angezeigt werden
            const renderedResources = (this.scheduleObject as any).resourceBase.renderedResources;
            if (!renderedResources || renderedResources.length <= groupIndex) {
                return;
            }
            const resourceData = renderedResources[groupIndex].resourceData as Record<string, any>;
            const parentResourceId = resourceData ? resourceData[parentIdField] : undefined;
            if (parentResourceId === undefined) {
                return;
            }

            // alle child resource id's finden die zur gruppe gehoren
            let childResources = (childResourceConfig.dataSource as Record<string, any>[]);
            childResources = childResources.filter((child) => {
                let childGroupIDObjOrIdStr = child[childGroupIdField];
                if (typeof childGroupIDObjOrIdStr == 'string') {
                    //legacy, falls childGroup wirklich string id ist, so wies laut sf beispiel auch ist,
                    //aber was weis ich? die grouppierungen machen sowieso keinen sinn in sf
                    return childGroupIDObjOrIdStr === parentResourceId;
                }
                if (typeof childGroupIDObjOrIdStr == 'object') {
                    return childGroupIDObjOrIdStr["ID"] === parentResourceId;
                }
                return false; //fallback
            });
            const childResourceIds = new Set(childResources.map(child => child[childIdField]));
            if (childResourceIds.size === 0) {
                return; // nix zu bearbeiten
            }

            // alle events finden die zur gruppe gehoeren
            const groupEvents = this.scheduleObject.getEvents().filter((event: Record<string, any>) =>
                event[parentEventField] === parentResourceId && childResourceIds.has(event[childEventField])
            );

            if (groupEvents.length < 1) {
                return;
            }

            const cacheKey = "group_" + groupIndex;
            const cacheForGroup: { [eventID: number]: { originalChildId: number, childField: string } } = (this.scheduleObject as any)["mds_timelineExpandEvCache"][cacheKey] = {};

            for (const ev of groupEvents) {
                // events cachen
                let eventID: number = ev.Id;
                cacheForGroup[eventID] = {
                    originalChildId: ev[childEventField],
                    childField: childEventField
                };

                // event clonen und group id auf undefined setzen
                let eventClone = (window as any).ejs.base.extend({}, ev, undefined, true) as Record<string, any>;
                eventClone[childEventField] = undefined;
                eventsToSave.push(eventClone);
            }
        }

        // aenderungen "speichern" und renderen
        if (eventsToSave.length > 0) {
            // events sollte zwar einzigartig sein aber syncfusion aber sicherheits halber
            const seenIds = new Set<string>();
            const uniqueEvents = eventsToSave.filter(item => {
                const id = item.Id;
                if (seenIds.has(id)) {
                    return false;
                } else {
                    seenIds.add(id);
                    return true;
                }
            });
            if (uniqueEvents.length > 0) {
                //aus unerklaerliche grunde funktioniert saveEvent im mini project aber nicht hier
                //wenn ich eines aus "Terminator" gelernt habe, ist es das zuerste erschiessen und dann fragen immer besser ist
                //deshalb erschiessen wir einfach die datenquelle YIPPPEEEE
                const currentEvents = this.events as Record<string, any>[];
                const eventsToUpdateMap = new Map(uniqueEvents.map(e => [e.Id, e]));
                const newDataSource = currentEvents.map(event =>
                    eventsToUpdateMap.get(event.Id) || event
                );

                this.events = newDataSource as any;
                this.scheduleObject.eventSettings.dataSource = this.events;
                this.scheduleObject.dataBind();
                //this.scheduleObject.saveEvent(uniqueEvents); //event render
            }
        }
    }
    private _onActionComplete(evt: { requestType: string, cancel: boolean, name: string, groupIndex?: number }) {
        // action: "dateNavigate"
        // name: "actionComplete"

        //console.debug(this.id + " _onActionComplete", evt.requestType, evt);

        switch (evt.requestType) {
            case "dateNavigate":
                this._visibleDateCells = [];
                this._firstVisibleCell = null;
                this.setupScrollEventListener();
                break;

            case "toolbarItemRendering":

                break;
        }

        if (this.nodesToFix.length) {
            //    if (this.getPrimitiveViewMode() == WebCalendar_ViewTypes.year) {
            //        for (let node of this.nodesToFix) {
            //            if (node.classList.contains("e-header-cells")) {
            //                // fixe Breite von 100px unschädlich machen
            //                this.UiModder.domStyle.set(node, "width", "150px"); // GEHT HIER IMMA NOCH NICHT
            //            }
            //        }
            //    }
        }

        if (this.enableTimelineGroupCollapse == true) {
            this.handle_timelineCollapseAndExpandGroups(evt);
        } else {
            this.timelineCollapseAndExpandGroups_resetAll();
        }
    }

    getItemNodes(targetItemID?: string): Array<{ node: HTMLElement, event: SyncFusionCalendarTypes.Syncfusion_EventItem<any> }> {
        let result = [];
        let nodes = dojoQuery(".e-appointment");

        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i] as HTMLElement;
            let nodeId = node.getAttribute("data-id");
            if (nodeId) {
                nodeId = nodeId.replace("Appointment_", "");
                for (let event of this.events) {
                    if (event.Id == nodeId && (targetItemID == event.Id || !targetItemID)) {
                        result.push({
                            node: node,
                            event: event
                        })

                        break;
                    }
                }
            }
        }
        return result;
    }

    showLoadingScreen(name: string, label?: string, ): void {


        this.addLoadingProgress(name);
    }
    private _standbyStopTimeout: number = null;
    hideLoadingScreen(name: string): void {
        //console.debug(this.id + " hideLoadingScreen", resource, this.loadingProgress);

        this.removeLoadingProgress(name);


    }

    private removeLoadingProgress(name: string): void {

        this.loadingProgress = this.loadingProgress.filter(e => e !== name);
        this.StandbyStop(name, this.id);

        //console.debug(this.id + " removeLoadingProgress: " + name, "remaining:", window.standbyManager.getRemainingSteps(this.id));

        if (this.loadingProgress.length === 0) {
            if (this._standbyStopTimeout) {
                clearTimeout(this._standbyStopTimeout);
            }
            this._standbyStopTimeout = setTimeout((name) => { // Give the schduler a second to render events (without timeout, mostly problematic with a lot of events).

                this.setupScrollEventListener();
                this.disableNode(this.syncFusionContainer, false);
                this.startViewportObserver();
            }, 1000);
        }
    }


    private addLoadingProgress(name: string, label?: string): void {
        //if (resource == "ViewMode") debugger;

        //console.debug(this.id + " addLoadingProgress", resource);
        let contains: boolean = false;
        for (let i = 0; i < this.loadingProgress.length; i += 1) {
            if (this.loadingProgress[i] === name) {
                contains = true;
                break;
            }
        }
        if (!contains) {
            this.StandbyStart(this.syncFusionContainer, name, label, null, this.id);
            this.loadingProgress.push(name);
        }
    }
    private _scrollEventListener: { node: HTMLElement, handle: any } = null;
    private setupScrollEventListener(): void {
        let schedule = this.scheduleObject as SyncFusionCalendarTypes.Syncfusion_ScheduleObject;


        if (this._scrollEventListener) {
            this._scrollEventListener.handle.remove();
        }

        if (this.isTimeLineMode()) {
            let nodes = dojoQuery(".e-schedule-table.e-outer-table .e-content-wrap");

            for (let i = 0; i < nodes.length; i++) {
                let node = nodes[i] as HTMLElement;
                let handle = on(node, "scroll", lang.hitch(this, this._onTimeLineScroll));
                this._scrollEventListener = {
                    handle: handle,
                    node: node
                };


                break;
            }

            //console.debug(this.id + " setupScrollEventListener", nodes)
        }

    }

    private scrollTimeoutHandle: any = null;
    private _onTimeLineScroll(evt: Event) {
        //console.debug(this.id + " _onTimeLineScroll", evt);

        if (this.scrollTimeoutHandle) clearTimeout(this.scrollTimeoutHandle);

        //if (this.scrollDateLocked == true) return;

        if (this.isTimeLineMode()) {
            this.scrollTimeoutHandle = setTimeout(lang.hitch(this, this.emitTimelineScroll), 200);
        }
    }

    public emitTimelineScroll() {


        if (!this.isTimeLineMode()) {
            return;
        }
        let targetDate = null;

        //console.debug(this.id + " emitTimelineScroll MAYBE?", targetDate, "scrolldate locked: " + this.scrollDateLocked);

        if (this.scrollTimeoutHandle) clearTimeout(this.scrollTimeoutHandle);

        if (targetDate) {
            //console.debug(this.id + " emitTimelineScroll with targetDate", this.dateTimeToString(targetDate, "dd.MM.yyyy HH:MM" ));
            if (this.scrollDateLocked != true) {
                this.scrollDate = targetDate;
            }

            this.emit("timelineScroll");
        }

        else {
            let dates = this.getVisibleDates();

            if (dates && dates.length) {

                let firstVisible = dates[0];
                let lastVisible = dates[dates.length - 1];

                let firstVisibleStr = this.dateTimeToString(firstVisible, "yyyy-MM-dd");
                let lastVisibleStr = this.dateTimeToString(lastVisible, "yyyy-MM-dd");

                let lastOfRange = this.getRangeDateLimitMax();
                let lastOfRangeStr = this.dateTimeToString(lastOfRange, "yyyy-MM-dd");

                if (lastVisibleStr == lastOfRangeStr) {
                    firstVisible = lastVisible;
                }


                if (this.scrollDateLocked != true) {
                    //console.debug(this.id + " updateTimelineScrollDate scrollDate", firstVisibleStr, lastVisibleStr, lastOfRangeStr);
                    this.scrollDate = new Date(firstVisible.getTime());

                }

                //console.debug(this.id + " emitTimelineScroll", this.scrollDate);

                this.emit("timelineScroll");
            }
        }
    }

    /**
     * Adjust cell hights on the scheduler. On default, the scheduler is in a compact form.
     * */
    adjustSchedulerHeight(bAutoAdjustHeight: boolean, forceRedraw?: boolean): void {
        this._adjustSchedulerHeight(bAutoAdjustHeight, forceRedraw, false);
    }
    private _adjustSchedulerHeight(bAutoAdjustHeight: boolean, forceRedraw: boolean, bIsRetry: boolean): void {
        try {
            let ownHeight = this.syncFusionContainer.clientHeight; // sichtbare Höhe
            if (ownHeight == 0) {
                // manchmal passierts beim Umschalten von Liste auf Woche, dass die Höhen nicht passen.
                // beim Entwickeln passierts nicht, race condition? unschöner patch:
                if (bIsRetry != true) {
                    setTimeout(lang.hitch(this, this._adjustSchedulerHeight, bAutoAdjustHeight, forceRedraw, true), 150);
                    return;
                }
            }
            // in allen Ansichten außer Monat gibt es pro halbe Stunde eine Zelle = 48 Elemente
            // Kopfzeile etc kommen dazu. also es wird keine exakte Wissenschaft. Mal auf 50 hochstellen.
            let heightPerElement = ownHeight / 50;
            let heightPerElementStr = heightPerElement.toFixed(0);
            //console.trace(this.id + " adjustSchedulerHeight - dynamic height", heightPerElementStr);
            this.syncFusionContainer.style.setProperty("--dynamicHeight", heightPerElementStr + "px");
        } catch (ex) {

        }
        this.UiModder.domClass.toggle(this.syncFusionContainer,
            "fixedHeight",
            bAutoAdjustHeight != true && !this.isTimeLineMode() && !(this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.month));

        if (this.autoAdjustHeight != bAutoAdjustHeight || forceRedraw == true) {
            this.refreshEvents();


        }

        this.autoAdjustHeight = bAutoAdjustHeight == true;
    }

    /**
     * It sets the flag to show or to hide the end time on an event and triggers an event repaint listener on the scheduler.
     * */
    showEndTime(show: boolean): void {
        if (show !== false) show = true;

        this.bShowEndTime = show === true;
        this.UiModder.domClass.toggle(this.syncFusionContainer, "showEndTime", this.bShowEndTime);
    }
    showStartTime(show: boolean): void {
        if (show !== false) show = true;


        this.bShowStartTime = show === true;
        this.UiModder.domClass.toggle(this.syncFusionContainer, "showStartTime", this.bShowStartTime);
    }
    private yearViewSettings: SyncFusionCalendarTypes.YearViewSettings = {
        firstMonthOfYear: 0,
        monthsCount: 12
    };
    setYearViewParameters(config: SyncFusionCalendarTypes.YearViewSettings): SyncFusionCalendarTypes.YearViewSettings {
        if (!config) return null;
        if (config.firstMonthOfYear >= 0 && config.firstMonthOfYear <= 11) {
            //view.firstMonthOfYear = config.firstMonthOfYear;
            this.yearViewSettings.firstMonthOfYear = config.firstMonthOfYear;
        }

        if (config.monthsCount >= 1 && config.monthsCount <= 24) {
            //view.monthsCount = config.monthsCount;
            this.yearViewSettings.monthsCount = config.monthsCount;
        }

        if (this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.year ||
            this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.timelineYear) {
            if (this.scheduleObject.activeView) {
                (this.scheduleObject as SyncFusionCalendarTypes.ScheduleObject_Stump).firstMonthOfYear = this.yearViewSettings.firstMonthOfYear;
                (this.scheduleObject as SyncFusionCalendarTypes.ScheduleObject_Stump).monthsCount = this.yearViewSettings.monthsCount;
                this.redrawEvents();
            } else {
                setTimeout(lang.hitch(this, this.setYearViewParameters, this.yearViewSettings), 10);
                return;
            }
            this.setScheduleSelectedDate(this.selectedDate);
        }

        return this.yearViewSettings;
        //let scheduler: SyncFusionCalendarTypes.ScheduleObject_Stump = this.scheduleObject;
        //for (let view of scheduler.views) {
        //    switch (view.option) {
        //        case SyncfusionCalendar_ViewModes.Year:
        //        case SyncfusionCalendar_ViewModes.TimelineYear:

        //            break;
        //    }
        //}


    }

    /**
     * Liefert pro matchender Resource ein Tupel (resourceId, resourceGroupId).
     * Wenn dieselbe resourceId in mehreren ResourceGroups existiert (z.B. Großer Saal in DEMO und LUZERN),
     * gibt's pro ResourceGroup einen eigenen Eintrag. _createEventsFromCalendarItemData nutzt das um pro
     * Tupel eine Event-Kopie mit eindeutiger ResourceGroupId zu erzeugen.
     */
    private getMatchingResourceTuples(event: WebcalendarTypes.WebCalendarItemData_Default): Array<{ resourceId: string, resourceGroupId: string }> {
        let tuples: Array<{ resourceId: string, resourceGroupId: string }> = [];
        if (!this.isTimeLineMode()) return tuples;
        try {
            for (let resource of this.resources) {
                if (event.hasOwnProperty(resource.keyProperty)) {
                    let keyValue = event[resource.keyProperty];
                    if (resource.id == keyValue) {
                        tuples.push({
                            resourceId: resource.id,
                            resourceGroupId: resource.groupId
                        });
                    }
                }
            }
        } catch (ex) {
        }
        return tuples;
    }

    private getMatchingResourceGroupId(event: WebcalendarTypes.WebCalendarItemData_Default): string {
        if (!this.isTimeLineMode()) return null;
        try {
            for (let resourceGroup of this.resourceGroups) {
                if (event.hasOwnProperty(resourceGroup.keyProperty)) {
                    let keyValue = event[resourceGroup.keyProperty];

                    if (resourceGroup.id == keyValue) {
                        return event[resourceGroup.keyProperty]
                    }
                }
            }
        } catch (ex) {

        }
        return null;
    }
    private _holidaysReg: Record<string, Array<WebcalendarTypes.Holiday>>;

    private _drawHolidays() {
        let viewmode = this.getCurrentViewMode();
        let firstDate = this.getCurrentSelectedDate("rangeStart");
        let lastDate = this.getCurrentSelectedDate("rangeEnd");
        if (!viewmode || !firstDate || !lastDate || !this._holidaysReg) return;
        if (!this.hasFeature("Webcalendar/displayHolidays")) return;

        switch (viewmode) {
            case WebcalendarTypes.WebCalendar_ViewModes.day:
            case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
            case WebcalendarTypes.WebCalendar_ViewModes.week:
            case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
            case WebcalendarTypes.WebCalendar_ViewModes.month:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:

                try {
                    let maxHeight = -1;

                    for (let dateKey in this._holidaysReg) {
                        let reg = this._holidaysReg[dateKey];
                        let nodes = this.syncFusionContainer.querySelectorAll(".dateInfoContainer[data-date='" + dateKey + "']");
                        for (let i = 0; i < nodes.length; i++) {
                            let node = nodes[i];


                            let existingAppts = node.querySelectorAll(".holiday");
                            for (let i = 0; i < existingAppts.length; i++) {
                                domConstruct.destroy(existingAppts[i]);
                            }

                            for (let appt of reg) {
                                let apptNode = this.UiModder.domConstruct.create("span", {
                                    className: "holiday",
                                    innerHTML: appt.description,
                                    title: appt.description
                                }, node);

                                if (appt.color) {
                                    let bgcolor = ColorHelpers.getHexColorFromProperty(appt.color, "BG");
                                    let txtcolor = ColorHelpers.getHexColorFromProperty(appt.color, "TXT");
                                    apptNode.style.setProperty("--bgColor", bgcolor);
                                    apptNode.style.setProperty("--txtColor", txtcolor);
                                }
                            }


                        }
                    }

                    let node = this.syncFusionContainer.querySelector(".e-header-row");
                    if (node) {
                        maxHeight = node.clientHeight;
                        let topLeftNode = this.syncFusionContainer.querySelector(".e-left-indent-wrap .e-header-cells.e-disable-dates") as HTMLElement;
                        if (topLeftNode && maxHeight > 30) {
                            topLeftNode.style.setProperty("--contentHeight", maxHeight + "px");
                            //this.adjustSchedulerHeight(this.autoAdjustHeight, true);

                        }
                    }


                } catch (ex) {
                    console.warn(this.id + " - error drawing holidays", this._holidaysReg, ex);
                }

                break;


        }
    }

    private _buildHolidayRegistry(data: Array<WebcalendarTypes.Holiday>) {
        if (!data) return;

        this._holidaysReg = {};

        let currentDate = this.getCurrentSelectedDate("rangeStart");
        let lastDate = this.getCurrentSelectedDate("rangeEnd");

        if (!lastDate) lastDate = currentDate;

        if (typeof (currentDate) == "string") {
            currentDate = new Date(currentDate);
        }

        if (typeof (lastDate) == "string") {
            lastDate = new Date(lastDate);
        }

        if (!currentDate) {

            return;
        }


        currentDate.setHours(0, 0, 0, 0);

        while (currentDate.valueOf() <= lastDate.valueOf()) {
            let keyStr = DateHelpers.dateToString(currentDate, "yyyy-MM-dd");
            let appts: Array<WebcalendarTypes.Holiday> = [];

            let currentVal = currentDate.valueOf();

            for (let appointment of data) {
                let compareDateStart = appointment.date_start;
                let compareDateEnd = appointment.date_end;
                if (typeof (compareDateStart) == "string") {
                    compareDateStart = new Date(compareDateStart);
                }
                if (typeof (compareDateEnd) == "string") {
                    compareDateEnd = new Date(compareDateEnd);
                }

                let valStart = compareDateStart.valueOf();
                let valEnd = compareDateEnd.valueOf();

                if (compareDateStart.valueOf() <= currentDate.valueOf() &&
                    compareDateEnd.valueOf() >= currentDate.valueOf()) {
                    appts.push(appointment);
                }
            }

            this._holidaysReg[keyStr] = appts;

            currentDate = dojoDate.add(currentDate, "day", 1);
        }
    }

    private _previousEventsData: SyncFusionCalendarTypes.Syncfusion_EventData<any>;
    private _eventSetLock: boolean = false;
    /**
     *  Sperrt oder entsperrt die setScheduleEvents-Methode.
     * - Falls während eines Locks setScheduleEvents aufgerufen wird, werden die Daten weggespeichert und noch nicht angewandt.
     * - Falls das Lock entfernt wird und weggespeicherte Daten vorhanden sind, werden diese nun mit setScheduleEvents gezeichnet.
     */
    setEventsDataLock(bValue: boolean) {
        this._eventSetLock = bValue;

        if (!this._eventSetLock && this._previousEventsData) {
            console.debug("setEventsDataLock", bValue, "resetting Events!");
            this.setScheduleEvents(this._previousEventsData);
        }
    }
    setHolidays(data: Array<WebcalendarTypes.Holiday>) {
        this._buildHolidayRegistry(data);
    }

    /**
     * Set scheduler event data and groups.
     * */
    setScheduleEvents<T>(eventsData: SyncFusionCalendarTypes.Syncfusion_EventData<T>): void {
        if (typeof (this.scheduleObject as any)["mds_timelineExpandEvCache"] != 'undefined') { //timeline cache clearen
            this.timelineCollapseAndExpandGroups_resetAll();
        }
        //console.debug(this.id + " setScheduleEvents", eventsData);
        this._previousEventsData = lang.clone(eventsData);

        // wenn die Ressourcen noch nicht fertig geladen im Timeline-Modus, dann erst mal unterbrechen und abwarten bis Lock weg ist
        if (this._eventSetLock) {
            return;
        }

        if (eventsData) {

            this.adjustSchedulerHeight(this.autoAdjustHeight, true);

            this._checkResetTimelineMode();
            let bNeedsOTHERgroup = false;
            this.allGroups = [];
            if (eventsData.DataGroupValues) {
                for (let i = 0; i < eventsData.DataGroupValues.length; i += 1) {
                    const group = eventsData.DataGroupValues[i];
                    this.allGroups.push({
                        id: group,
                        text: group
                    });
                }
            }

            this.events = [];

            for (let i = 0; i < eventsData.items.length; i += 1) {
                let calendarItemData: WebcalendarTypes.WebCalendarItemData_Default = eventsData.items[i];

                let result = this._createEventsFromCalendarItemData(calendarItemData);
                let events = result.events;
                
                this.events = this.events.concat(events);

            }


            this.scheduleObject.eventSettings.dataSource = <Object[]>window.ej.base.extend([], this.events, null, true);
            //this.scheduleObject.addEvent(this.events); // warum eigentlich nicht mit der Methode?

            this.emit("setScheduleEventsComplete", { callback: this._onCallbackAdditionalEventData, scope: this });

            // kein AfterRender-Timeout? d.h. es gab nichts zu zeichnen!
            if (!this._afterEventRenderedHandle) {
                //this._onEventsRenderFinished();
                this._afterEventRenderedHandle = setTimeout(lang.hitch(this, this._onEventsRenderFinished), 100); // warten bis Syncfusion noch tausend mal alles gezeichnet hat
            }


        } else {
            this.adjustSchedulerHeight(this.autoAdjustHeight, true);
        }

        if (this.isTimeLineMode()) {
            this.scrollTo(null, this.scrollDate);
            //this.emitTimelineScroll(this.scrollDate);
        }

        this.hideLoadingScreen('Events');
    }

    private _createEventsFromCalendarItemData(calendarItemData: WebcalendarTypes.WebCalendarItemData_Default): { groupValues: string[], events: SyncFusionCalendarTypes.Syncfusion_EventItem<any>[] } {
        let result = [];
        // Tupel statt nur ResourceIds, weil dieselbe Resource (z.B. "Großer Saal") in mehreren
        // ResourceGroups (DEMO, LUZERN) auftauchen kann. Pro Tupel wird ein eigenes Event erzeugt
        // damit es in jeder zugehörigen Top-Group erscheint.
        let resourceTuples = this.getMatchingResourceTuples(calendarItemData);
        let fallbackResourceGroupId = this.getMatchingResourceGroupId(calendarItemData);

        if (!resourceTuples || !resourceTuples.length) {
            resourceTuples = [{ resourceId: "-none-", resourceGroupId: fallbackResourceGroupId }];
        }

        let newGroups = [];
        let bNeedsOTHERgroup = false;

        for (let tuple of resourceTuples) {
            let resourceId = tuple.resourceId;
            let resourceGroupId = tuple.resourceGroupId != null ? tuple.resourceGroupId : fallbackResourceGroupId;

            newGroups.push(calendarItemData.groupValue);

            if (!this.hasGroup(this.allGroups, calendarItemData.groupValue)) {
                if (this.hasFeature("Webcalendar/DynamicExtendGroups")) {
                    this.allGroups.push({
                        id: calendarItemData.groupValue,
                        text: calendarItemData.groupValue
                    });
                } else {
                    if (this.hasFeature("Webcalendar/HideOtherGroupingValue")) {
                        // "sonstige" sind nicht zugelassen
                    } else {

                        // prüfen ob "sonstige" schon angelegt:
                        if (!this.hasGroup(this.allGroups, this.otherGroupValue)) {

                            this.allGroups.push({
                                id: this.otherGroupValue,
                                text: this.otherGroupLabel
                            });


                        }

                        // Event bekommt die "sonstige"-Gruppe
                        calendarItemData.groupValue = this.otherGroupValue;
                    }
                }
            }

            let newEvent: SyncFusionCalendarTypes.Syncfusion_EventItem<any> = {
                // Id muss eindeutig pro (Resource, ResourceGroup) sein, sonst dedupliziert SyncFusion
                // die mehrfachen Kopien zu einer einzigen.
                Id: calendarItemData.id + "-" + resourceId + "-" + (resourceGroupId || "none"),
                eventId: calendarItemData.id,
                Subject: calendarItemData.barview_text,
                StartTime: calendarItemData.startTime/* + '.000Z'*/,
                EndTime: calendarItemData.endTime/* + '.000Z'*/,
                GroupId: calendarItemData.groupValue,
                ResourceId: resourceId,
                ResourceGroupId: resourceGroupId,
                IsAllDay: calendarItemData.allDay == true,
                Object: calendarItemData,
                Location: calendarItemData[this.columnView_bodyText_attribute] ? calendarItemData[this.columnView_bodyText_attribute] : null
            };

            result.push(newEvent);
        }

        return {
            events: result,
            groupValues: newGroups
        }
    }
    /**
     * Ein einzelnes Event updaten. Alle Vorkommen des Events (in verschiedenen Gruppen oder Ressourcen) werden aus Syncfusion-Kalender gelöscht und anschließend neu erzeugt.
     * @param newData
     * @param bAddIfNew
     * @returns
     */
    updateEvent<T = any>(newData: WebcalendarTypes.WebCalendarItemData_Default, bAddIfNew?: boolean) {
        if (!newData) return;
        let existingEvent = this.getEventById(newData.id);
        let convertedEventsResult = this._createEventsFromCalendarItemData(newData);
        
        if (existingEvent) {
            
            // alle mit der Eventid suchen, die ressourcen-ID dann von den Vorkommen übernehmen
            let index = this._getEventIndexById(newData.id);
            while (index != -1) {

                let event = this.events[index];
                this.scheduleObject.deleteEvent(event.Id, "Delete");
                this.events.splice(index, 1);

                index = this._getEventIndexById(event.eventId, null, index);
            }

            
            if (convertedEventsResult.events) {
                this.scheduleObject.addEvent(convertedEventsResult.events);
                this.events = this.events.concat(convertedEventsResult.events);
            }

        } else if (bAddIfNew) {
            this.scheduleObject.addEvent(convertedEventsResult.events);
            this.events = this.events.concat(convertedEventsResult.events);
        }
    }

    private _getEventIndexById(eventID: string, resourceId?: string, startIndex: number = 0) {
        let i = startIndex;
        if (i < 0) i = 0;
        for (i = 0; i < this.events.length; i++) {
            let event = this.events[i];
            if (event.eventId == eventID && (event.ResourceId == resourceId || resourceId == undefined)) {
                return i;
            }
        }

        return -1;
    }

    private getEventById<T = any>(eventID: string, resourceId?: string): SyncFusionCalendarTypes.Syncfusion_EventItem<T> {
        if (!this.events?.length) return null;

        let results = this.events.filter(event => event.eventId == eventID && (event.ResourceId == resourceId || !resourceId));

        if (results.length > 0) return results[0];
    }

    private _onCallbackAdditionalEventData<T = any>(additionalEvents: Array<SyncFusionCalendarTypes.Syncfusion_EventItem<T>>) {
        for (let i = 0; i < additionalEvents.length; i++) {
            this.events.push(additionalEvents[i]);
        }

        this.scheduleObject.eventSettings.dataSource = <Object[]>window.ej.base.extend([], this.events, null, true);
        //this.scheduleObject.addEvent(this.events); // neuere Methode?
    }

    private currentQuicksearchTerm: string;

    highlightItemsByKeyword(searchString: string) {
        let items = this.getItemNodes();
        //if (searchString != this.currentQuicksearchTerm) {
        //    setTimeout(lang.hitch(this, this.emit, "search", searchString), 10);
        //    this.currentQuicksearchTerm = searchString;
        //}

        this.currentQuicksearchTerm = searchString;

        for (let item of items) {
            let node = item.node;
            this.UiModder.domClass.remove(node, "searchHighlight");
        }

        if (searchString) {
            this.UiModder.domClass.add(this.syncFusionContainer, "quicksearchActive");

            searchString = searchString.toLowerCase();

            let highlightedItems = items.filter(function (item) {
                let str = item.event.Subject;
                if (str) {
                    str = str.toLowerCase();
                    if (str.indexOf(searchString) != -1) {
                        return true;
                    }
                }

                str = item.event.Location;
                if (str) {
                    str = str.toLowerCase();
                    if (str.indexOf(searchString) != -1) {
                        return true;
                    }
                }

                return false;
            });

            for (let item of highlightedItems) {
                this.UiModder.domClass.add(item.node, "searchHighlight");
            }


            this.emit("searchresult", highlightedItems.length);

            if (highlightedItems.length) {
                this.scrollToFirstEvent(highlightedItems);
            }
            else {

            }


        } else {
            this.UiModder.domClass.remove(this.syncFusionContainer, "quicksearchActive");
        }
    }

    /**
     * Die vertikalen Ressourcengruppen setzen
     * */
    setTimelineResources(resources: Array<WebcalendarTypes.WebCalendarResourceData<any>>): void {

        console.debug(this.id + " setTimelineResources", resources);

        this._checkResetTimelineMode();


        for (let i = 0; i < resources.length; i += 1) {
            let resource = resources[i];

            for (let j = 0; j < resource.dataSource.length; j += 1) {
                let data = resource.dataSource[j];
                let colorPathBG = resource.colorField;
                let colorTXT = null;
                let colorBG = null;

                if (resource.colorFieldBG) colorPathBG = resource.colorFieldBG;

                if (colorPathBG) {
                    colorBG = this.PitHelper.getEntityAttributeValue(data, colorPathBG);
                }

                if (resource.colorFieldTXT) {
                    colorTXT = this.PitHelper.getEntityAttributeValue(data, resource.colorFieldTXT);
                }

                if (!colorTXT && colorBG) {
                    if (this.isDarkColor(colorBG)) colorTXT = "var(--bright)";
                    else colorTXT = "var(--dark)";
                }

                // groupId kann vom Backend als Entity-Reference-Object kommen (z.B. {ID: "...", $Displayname: "..."}).
                // Die ResourceGroups werden aber mit String-IDs angelegt, deshalb hier normalisieren -
                // sonst matched res.groupId == grp.id im Cell-Renderer nie und SyncFusion gruppiert alle Items
                // in denselben Bucket (= cross-contamination zwischen Top-Groups).
                let rawGroupId: any = data[resource.groupIDField];
                let normalizedGroupId: string = null;
                if (rawGroupId != null) {
                    if (typeof rawGroupId === "object") {
                        normalizedGroupId = rawGroupId.ID || rawGroupId.id || null;
                    } else {
                        normalizedGroupId = rawGroupId;
                    }
                }

                let resourceData: WebcalendarTypes.SyncfusionCalendarResource = {
                    id: data.ID,
                    label: data[resource.textField],
                    groupId: normalizedGroupId,
                    _originData: data,
                    descriptorId: resource.DescriptorId,
                    colorationBG: colorBG,
                    colorationTXT: colorTXT,
                    node: null,
                    keyProperty: resource.field,
                    type: resource.resourceType
                };
                //console.debug("created resource data", resourceData, data);


                if (resource.ResourceGroupsDescriptor?.dataSource) {
                    // resourceGroups Datasource verarbeiten
                    //
                    for (let x = 0; x < resource.ResourceGroupsDescriptor.dataSource.length; x += 1) {
                        let groupData = resource.ResourceGroupsDescriptor.dataSource[x];

                        let alreadyExists = false;
                        for (let a = 0; a < this.resourceGroups.length; a++) {
                            let existingItem = this.resourceGroups[a];

                            if (existingItem.id == groupData[resource.ResourceGroupsDescriptor.idField]) {
                                alreadyExists = true;
                                break;
                            }
                        }

                        if (alreadyExists === false) {
                            let colorPathBG = resource.ResourceGroupsDescriptor.colorField;
                            let colorTXT = null;
                            let colorBG = null;

                            if (resource.ResourceGroupsDescriptor.colorFieldBG) colorPathBG = resource.ResourceGroupsDescriptor.colorFieldBG;

                            if (colorPathBG) {
                                colorBG = this.PitHelper.getEntityAttributeValue(groupData, colorPathBG);
                            }

                            if (resource.ResourceGroupsDescriptor.colorFieldTXT) {
                                colorTXT = this.PitHelper.getEntityAttributeValue(groupData, resource.ResourceGroupsDescriptor.colorFieldTXT);
                            }

                            if (!colorTXT && colorBG) {
                                if (this.isDarkColor(colorBG)) colorTXT = "var(--bright)";
                                else colorTXT = "var(--dark)";
                            }

                            let resourceGroupData: WebcalendarTypes.SyncfusionCalendarResource = {
                                _originData: groupData,
                                id: groupData[resource.ResourceGroupsDescriptor.idField],
                                label: groupData[resource.ResourceGroupsDescriptor.textField],
                                colorationBG: colorBG,
                                colorationTXT: colorTXT,
                                keyProperty: resource.ResourceGroupsDescriptor.field,
                                groupId: null,
                                descriptorId: resource.DescriptorId,
                                node: null,
                                type: "resourceGroup"
                            };
                            //console.debug("created resource group data", resourceGroupData);

                            this.resourceGroups.push(resourceGroupData);
                        }
                    }
                }


                let alreadyExists = false;
                //for (let j = 0; j < this.resources.length; j++) {
                //    let existingItem = this.resources[j];

                //    if (existingItem.id == data.ID) {
                //        alreadyExists = true;
                //        break;
                //    }
                //}

                if (alreadyExists == false) {
                    this.resources.push(resourceData);
                }
            }


        }

        if (this.resourceGroups.length) {
            this.groups = ['ResourceGroups', 'Resources'];
        } else {
            this.groups = ['Resources'];
        }

        this.scheduleObject.resources[2].dataSource = <Object[]>window.ej.base.extend([], this.resourceGroups, null, true);
        this.scheduleObject.resources[1].dataSource = <Object[]>window.ej.base.extend([], this.resources, null, false);


        if (!this.scheduleObject.group.resources.includes('Resources')) {
            this.scheduleObject.group.resources = <String[]>window.ej.base.extend([], this.groups, null, true);
        }

        // das Lock entfernen: falls in der Zwischenzeit schon Eventdaten dahergekommen sind, wurden die zwischengeparkt und jetzt erst gezeichnet:
        this.setEventsDataLock(false);

        setTimeout(lang.hitch(this, this.hideLoadingScreen, 'Resources'), 100);
    }

    setResourceClick(callback: Function) {
        this._resourceClickFct = callback;

        if (this.resources) {
            for (let resource of this.resources) {
                if (resource.node) {
                    if (this._resourceClickFct) {
                        on(resource.node, "click", lang.hitch(this, this._resourceClickFct, resource));
                        this.UiModder.domClass.add(resource.node, "clickable");
                    } else {

                    }
                }
            }
        }
    }

    private _resourceClickFct: Function = null;

    /**
     * Remove all room resources and grouping.
     * */
    removeAllGroupingResources(): void {
        if (this.resources.length > 0) {
            this.resources = [];
            //this.resourceGroups = [];
            this.groups = [];
            this.scheduleObject.resources[1].dataSource = <Object[]>window.ej.base.extend([], this.resources, null, true);
            //this.scheduleObject.resources[2].dataSource = <Object[]>window.ej.base.extend([], this.resourceGroups, null, true);
            this.scheduleObject.group.resources = <String[]>window.ej.base.extend([], this.groups, null, true);
        }
    }

    /**
     * Remove a spesific room type from the resources.
     * */
    removeResourceGroup(descriptorId: string): void {
        const dataSource = [];

        // scheduleObject.resources[1] ist die Definition für die Ressourcen (0 = Gruppen, 2 = Ressourcengruppen
        for (let i = 0; i < this.scheduleObject.resources[1].dataSource.length; i += 1) {
            if (this.scheduleObject.resources[1].dataSource[i].descriptorId !== descriptorId) {
                dataSource.push(this.scheduleObject.resources[1].dataSource[i]);
            }
        }

        this.removeAllGroupingResources();
        this.resources = dataSource;


        this.scheduleObject.resources[1].dataSource = <Object[]>window.ej.base.extend([], this.resources, null, true);
        if (this.resources.length === 0) {
            this.groups = [];
            this.scheduleObject.group.resources = <String[]>window.ej.base.extend([], this.groups, null, true);
        } else {
            // Gruppierung wiederherstellen, weil removeAllGroupingResources sie geleert hat.
            // Sonst zeigt SyncFusion alle Events ungruppiert (= "kein Filter aktiv")
            // wenn ein Resource Group deaktiviert wird, während ein anderer noch aktiv ist.
            if (this.resourceGroups.length) {
                this.groups = ['ResourceGroups', 'Resources'];
            } else {
                this.groups = ['Resources'];
            }
            if (!this.scheduleObject.group.resources.includes('Resources')) {
                this.scheduleObject.group.resources = <String[]>window.ej.base.extend([], this.groups, null, true);
            }
        }
        this.hideLoadingScreen('Resources');
    }

    /**
     * Show current time indicator.
     * */
    showTimeIndicator(show: boolean): void {
        if (this.scheduleObject.showTimeIndicator !== show) {
            this.scheduleObject.showTimeIndicator = show;
        }
    }

    /**
     * Gruppiert die angezeigten Daten in Gruppenspalten.
     * Gruppen ohne Einträge werden ausgeblendet.
     * Wenn keine Gruppen übrig bleiben (keine Daten, keine Daten in verfügbaren Gruppen) wird showAllGroups aufgerufen.
     * @param show
     */
    showGroups(show: boolean): void {
        if (show) {
            if (this.scheduleObject.eventSettings.dataSource.length > 0) {
                const actualUsedGroups = [];
                for (let event of this.events) {
                    if (this.hasGroup(this.allGroups, event.GroupId)) {
                        if (!this.hasGroup(actualUsedGroups, event.GroupId)) {
                            for (let group of this.allGroups) {
                                if (group.id == event.GroupId) {
                                    actualUsedGroups.push(group);
                                }
                            }

                        }
                    }

                }

                // Achtung, die Reihenfolge stimmt jetzt ggf. nicht mehr mit den allGroups überein
                // #29469
                let sortedGroups = [];
                for (let grp of this.allGroups) {
                    if (this.hasGroup(actualUsedGroups, grp.id)) {
                        sortedGroups.push(grp);
                    }
                }

                this.groups = ['Groups'];
                this.scheduleObject.resources[0].dataSource = <Object[]>window.ej.base.extend([], sortedGroups, null, true);
                this.scheduleObject.group.resources = <String[]>window.ej.base.extend([], this.groups, null, true);
                this.scheduleObject.group.byDate = true;
            } else {
                this.showAllGroups(true);
            }
        } else if (!this.scheduleObject.group.resources.includes('Resources') && this.scheduleObject.group.resources.length > 0) {
            this.groups = [];
            this.scheduleObject.group.resources = <String[]>window.ej.base.extend([], this.groups, null, true); // TODO REMOVE ONLY Groups
            this.scheduleObject.group.byDate = false;
        }
    }

    /**
     * Gruppiert die angezeigten Daten in Gruppenspalten. Es werden immer alle verfügbaren Gruppen angezeigt.
     * @param show
     */
    showAllGroups(show: boolean): void {
        //console.debug(this.id + " showAllGroups", show, this.allGroups);

        if (show && this.allGroups.length > 0) {
            this.groups = ['Groups'];
            this.scheduleObject.resources[0].dataSource = <Object[]>window.ej.base.extend([], this.allGroups, null, true);
            this.scheduleObject.group.resources = <string[]>window.ej.base.extend([], this.groups, null, true);
            this.scheduleObject.group.byDate = true;
        } else if (this.scheduleObject.eventSettings.dataSource.length > 0) {
            this.showGroups(true);
        }
    }

    /**
     * Set the color id for the events and trigger a repaint of the events on the scheduler.
     * */
    addColorToRegistry(id: string, classname: string): void {
        //console.debug("setScheduleEventColoration", classname, this.itemColorationValues);

        let colorReg = this.getColorEntryByClass(classname);
        if (colorReg) {
            colorReg.colorId = id;

            if (this.scheduleObject.eventSettings.dataSource.length > 0) {
                this.scheduleObject.refreshEvents();
            }
        } else {
            this.itemColorationValues.push({
                classname: classname,
                colorId: id
            });
        }
    }

    refreshEvents() {
        if (!this.scheduleObject) return;

        //console.debug(this.id + " refreshEvents");

        try {
            this.scheduleObject.refreshEvents();
        } catch (ex) {
            console.warn(ex);
        }

        if (this.isTimeLineMode()) this.startViewportObserver();

    }
    redrawEvents() {
        this.refreshEvents();
    }
    getCurrentViewMode(): WebcalendarTypes.WebCalendar_ViewModes {
        return this.currentView;
    }
    getPrimitiveViewMode(viewmode?: WebcalendarTypes.WebCalendar_ViewModes): WebcalendarTypes.WebCalendar_ViewTypes {
        if (!viewmode) viewmode = this.getCurrentViewMode();

        switch (viewmode) {
            case WebcalendarTypes.WebCalendar_ViewModes.day:
            case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:

                return WebcalendarTypes.WebCalendar_ViewTypes.day;
                break;
            case WebcalendarTypes.WebCalendar_ViewModes.week:
            case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                return WebcalendarTypes.WebCalendar_ViewTypes.week;

                break;
            case WebcalendarTypes.WebCalendar_ViewModes.month:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                return WebcalendarTypes.WebCalendar_ViewTypes.month;

                break;
            case WebcalendarTypes.WebCalendar_ViewModes.year:
            case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                return WebcalendarTypes.WebCalendar_ViewTypes.year;

                break;

            case WebcalendarTypes.WebCalendar_ViewModes.listView:
                return WebcalendarTypes.WebCalendar_ViewTypes.list;
                break;
        }
    }
    private _createRangeRegistry(baseDate?: Date) {
        if (!baseDate) baseDate = this.scheduleObject.selectedDate;

        this.timelineRanges = [];

        let rangeStart: Date = null;

        let rangeEnd: Date = null;


        switch (this.getCurrentViewMode()) {

            case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:

                // 1.1. des Jahres bis 31.12. des Jahres
                rangeStart = new Date(baseDate.valueOf())

                rangeStart.setMonth(0, 1); // Monatserster
                rangeStart.setHours(0, 0, 0, 0);

                rangeEnd = new Date(rangeStart.valueOf());
                rangeEnd = dojoDate.add(rangeEnd, "year", 1);
                rangeEnd = dojoDate.add(rangeEnd, "day", -1);
                rangeEnd.setHours(23, 59, 59, 999);

                this.timelineRanges.push({
                    earliestDate: rangeStart,
                    latestDate: rangeEnd
                });
                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:

                // 2. Monat zurück

                rangeStart = new Date(baseDate.valueOf())

                rangeStart.setDate(1); // Monatserster
                rangeStart.setHours(0, 0, 0, 0);

                rangeEnd = new Date(rangeStart.valueOf());
                rangeEnd = dojoDate.add(rangeEnd, "day", dojoDate.getDaysInMonth(rangeStart) - 1);
                rangeEnd.setHours(23, 59, 59, 999);

                this.timelineRanges.push({
                    earliestDate: rangeStart,
                    latestDate: rangeEnd
                });


                // 1. Monat zurück
                rangeStart = dojoDate.add(rangeStart, "month", 1);
                rangeEnd = dojoDate.add(rangeEnd, "day", dojoDate.getDaysInMonth(rangeStart));
                rangeEnd.setHours(23, 59, 59, 999);

                this.timelineRanges.push({
                    earliestDate: rangeStart,
                    latestDate: rangeEnd
                });

                // aktueller Monat
                rangeStart = dojoDate.add(rangeStart, "month", 1);
                rangeEnd = dojoDate.add(rangeEnd, "day", dojoDate.getDaysInMonth(rangeStart));
                rangeEnd.setHours(23, 59, 59, 999);

                this.timelineRanges.push({
                    earliestDate: rangeStart,
                    latestDate: rangeEnd
                });

                // kommender Monat
                rangeStart = dojoDate.add(rangeStart, "month", 1);
                rangeEnd = dojoDate.add(rangeEnd, "day", dojoDate.getDaysInMonth(rangeStart));
                rangeEnd.setHours(23, 59, 59, 999);

                this.timelineRanges.push({
                    earliestDate: rangeStart,
                    latestDate: rangeEnd
                });


                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
                rangeStart = new Date(baseDate.getTime())

                rangeStart.setHours(0, 0, 0, 0);

                rangeEnd = new Date(rangeStart.getTime());
                rangeEnd.setHours(23, 59, 59, 999);

                for (let i = 0; i < 7; i++) {
                    this.timelineRanges.push({
                        earliestDate: rangeStart,
                        latestDate: rangeEnd
                    });

                    rangeStart = dojoDate.add(rangeStart, "day", 1);
                    rangeEnd = dojoDate.add(rangeEnd, "day", 1);
                }

                break;

            case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
                rangeStart = new Date(baseDate.getTime())

                rangeStart.setHours(0, 0, 0, 0);

                rangeEnd = new Date(rangeStart.getTime());
                rangeEnd.setHours(23, 59, 59, 999);

                this.timelineRanges.push({
                    earliestDate: rangeStart,
                    latestDate: rangeEnd
                });
                break;

            default:
                // keine Ranges erstellen
                break;
        }

        //console.debug(this.id + " timeLineRanges created: ", this.timelineRanges, this.scheduleObject.currentView);

    }

    /**
     * Set scheduler view mode to timeline or normal calender.
     * */
    setViewMode(targetMode: WebcalendarTypes.WebCalendar_ViewModes): void {

        if (!targetMode) targetMode = this.getCurrentViewMode();

        let bSetTimelineMode =
            targetMode == WebcalendarTypes.WebCalendar_ViewModes.timelineDay ||
            targetMode == WebcalendarTypes.WebCalendar_ViewModes.timelineDetail ||
            targetMode == WebcalendarTypes.WebCalendar_ViewModes.timelineYear ||
            targetMode == WebcalendarTypes.WebCalendar_ViewModes.timelineOverview;



        if (bSetTimelineMode == this._isTimelineMode && targetMode == this.getCurrentViewMode()) {
            return;
        }

        this._isTimelineMode = bSetTimelineMode;
        this.currentView = targetMode;


        console.debug("setScheduleViewTimeline", targetMode, "this.selectedDate:", this.selectedDate, "scheduler.selectedDate:", this.scheduleObject.selectedDate, "scrolldate?", this.scrollDate);

        if (!this.selectedDate) {
            this.selectedDate = this.scheduleObject.selectedDate;
        }

        //this.showLoadingScreen('ViewMode');

        if (this._isTimelineMode) {
            this.scrollDateLocked = true;

            if (typeof this.scrollDate == "number") {
                this.scrollDate = new Date(this.scrollDate);
            }

            if (this.scrollDate && this.scrollDate.getTime) {
                this.selectedDate = new Date(this.scrollDate.getTime());
            }
            else {
                console.warn(this.id + ": no scrolldate?", this.scrollDate)
                this.scrollDate = this.scheduleObject.selectedDate ? new Date(this.scheduleObject.selectedDate.valueOf()) : new Date();
            }
            //console.debug(this.id + " setScheduleViewTimeline, scrolldate is set to: ", this.dateTimeToString(this.scrollDate, "dd.MM.yyyy HH:mm"), "selectedDate is: ", this.dateTimeToString(this.selectedDate, "dd.MM.yyyy HH:mm"));
            this.groups = [];
            this.scheduleObject.resources[0].dataSource = <Object[]>window.ej.base.extend([], [], null, true);
            this.scheduleObject.group.resources = <string[]>window.ej.base.extend([], this.groups, null, true);

            switch (targetMode) {

                case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:

                    this.scheduleCalendarInterval = 1;
                    this._selectScheduleView("Year");


                    // das für Syncfusion genutzte interne selectedDate auf 1.1. setzen:
                    let startDateYear = new Date((this.selectedDate).getTime());
                    startDateYear.setDate(1);
                    startDateYear.setMonth(0);
                    setTimeout(lang.hitch(this, function () {
                        this.setScheduleSelectedDate(startDateYear);
                        this.scrollTo(null, this.scrollDate);
                        this.emitTimelineScroll();
                    }), 500);


                    setTimeout(lang.hitch(this, function () {

                        this.scrollDateLocked = false;
                    }), 3000);

                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:

                    this.scheduleCalendarInterval = 4;
                    this._selectScheduleView("Month");


                    // das für Syncfusion genutzte interne selectedDate zurückrechnen:
                    let startDate = new Date((this.selectedDate).getTime() - 60 * 60 * 24 * 60 * 1000); // 60 Tage zurück
                    setTimeout(lang.hitch(this, function () {
                        this.setScheduleSelectedDate(startDate);
                        this.scrollTo(null, this.scrollDate);
                        this.emitTimelineScroll();
                    }), 500);


                    setTimeout(lang.hitch(this, function () {

                        this.scrollDateLocked = false;
                    }), 3000);

                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:

                    this.scheduleCalendarInterval = 7;
                    this._selectScheduleView("Day");

                    startDate = new Date((this.selectedDate).getTime() - 60 * 60 * 24 * 3 * 1000); // three days back
                    setTimeout(lang.hitch(this, function () {
                        this.setScheduleSelectedDate(startDate);
                        this.scrollTo(null, this.scrollDate);
                        this.emitTimelineScroll();

                    }), 500);


                    setTimeout(lang.hitch(this, function () {

                        this.scrollDateLocked = false;
                    }), 3000);

                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineDay: // UNGENUTZT!!

                    this.scheduleCalendarInterval = 1;
                    this._selectScheduleView("Day");

                    startDate = new Date((this.selectedDate).getTime());// - 60 * 60 * 24 * 1 * 1000); // one day back
                    setTimeout(lang.hitch(this, function () {
                        this.setScheduleSelectedDate(startDate);
                    }), 500);


                    //setTimeout(lang.hitch(this, function () {
                    //    this.scrollTo(null, this.scrollDate);
                    //    //this.scrollDateLocked = false;
                    //    this.emitTimelineScroll();
                    //}), 3000);

                    break;
            }

        } else {
            this._selectScheduleView(this.scheduleObject.currentView.replace('Timeline', ''), this.scrollDate);
            //this.scrollDate = null;
        }


        this.hideLoadingScreen('ViewMode');
    }

    private _firstVisibleCell: HTMLElement;
    private _viewportObserverCallback(entries, observer) {
        let currentFirstVisibleElement = null;

        //console.log("_viewportObserverCallback visibleDateCells", entries, this._visibleDateCells);
        if (this._visibleDateCells.length) currentFirstVisibleElement = this._visibleDateCells[0];


        for (let i = 0; i < entries.length; i++) {
            let entry = entries[i];

            let existingIndex = this._visibleDateCells.indexOf(entry.target);

            if (entry.isIntersecting) {
                if (existingIndex == -1) {
                    this._visibleDateCells.push(entry.target);
                }
            }
            else {
                if (existingIndex > -1) {
                    this._visibleDateCells.splice(existingIndex, 1);
                }
            }
        }

        if (this._visibleDateCells.length > 0) this._firstVisibleCell = this._visibleDateCells[0] as HTMLElement;

        //if (!this._visibleDateCells.length && currentFirstVisibleElement) this._visibleDateCells.push(currentFirstVisibleElement);


    }

    public getCurrentSelectedDate(target: "selected" | "visibleStart" | "visibleEnd" | "rangeStart" | "rangeEnd" = "selected"): Date {
        let currentView = this.getCurrentViewMode();
        switch (target) {
            case "selected":
            default:
                if (this.scheduleObject.selectedDate?.valueOf) {
                    return new Date((this.scheduleObject.selectedDate as Date).valueOf());
                }
                return new Date();

                break;

            case "visibleStart":
                let datesForStart = this.getVisibleDates();
                if (datesForStart.length) return datesForStart[0];
                break;
            case "visibleEnd":
                var datesForEnd = this.getVisibleDates();
                if (datesForEnd.length) return datesForEnd.pop();
                break;

            case "rangeStart":
                let baseDateForStart = this.getCurrentSelectedDate();
                baseDateForStart.setHours(0, 0, 0, 0);

                switch (currentView) {

                    case WebcalendarTypes.WebCalendar_ViewModes.day:
                    case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                        return baseDateForStart;
                        break;

                    case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                    case WebcalendarTypes.WebCalendar_ViewModes.week:
                        let currentDay = baseDateForStart.getDay();
                        // 0 = Sonntag
                        // 1 = Montag, usw
                        // d.h. für jeden Tag mehr als 0 zurückzählen zu Sonntag:
                        if (currentDay) baseDateForStart = dojoDate.add(baseDateForStart, "day", -1 * currentDay);

                        // dann eins nach vorne, weil wir Montag wollen
                        let result = dojoDate.add(baseDateForStart, "day", 1);
                        return result;
                        break;
                    case WebcalendarTypes.WebCalendar_ViewModes.month:
                        baseDateForStart.setDate(1);
                        return baseDateForStart;
                        break;

                    case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
                    case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
                    case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                        let value = this.getRangeDateLimitMin();
                        if (!value) {
                            this._createRangeRegistry();
                            value = this.getRangeDateLimitMin();
                        }
                        return value;
                        break;

                    case WebcalendarTypes.WebCalendar_ViewModes.year:
                    case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                        let firstMonth = new Date(baseDateForStart.valueOf());
                        firstMonth.setMonth(this.yearViewSettings.firstMonthOfYear, 1);
                        return firstMonth;
                        break;

                }
                break;
            case "rangeEnd":
                let baseDateForEnd = this.getCurrentSelectedDate("rangeStart");
                baseDateForEnd.setHours(23, 59, 59, 0);

                switch (currentView) {

                    case WebcalendarTypes.WebCalendar_ViewModes.day:
                        return baseDateForEnd;
                        break;
                    case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                        baseDateForEnd = dojoDate.add(baseDateForEnd, "day", 2);
                        return baseDateForEnd;
                        break;
                    case WebcalendarTypes.WebCalendar_ViewModes.week:
                        baseDateForEnd = dojoDate.add(baseDateForEnd, "day", 6);
                        return baseDateForEnd;
                        break;
                    case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                        baseDateForEnd = dojoDate.add(baseDateForEnd, "day", 13);
                        return baseDateForEnd;
                        break;
                    case WebcalendarTypes.WebCalendar_ViewModes.month:
                        baseDateForEnd = dojoDate.add(baseDateForEnd, "month", 1);
                        baseDateForEnd.setHours(0, 0, 0, 0);
                        baseDateForEnd.setSeconds(-1);
                        return baseDateForEnd;
                        break;

                    case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
                    case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
                    case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:

                        let value = this.getRangeDateLimitMax();
                        if (!value) {
                            this._createRangeRegistry();
                            value = this.getRangeDateLimitMax();
                        }
                        return value;
                        break;

                    case WebcalendarTypes.WebCalendar_ViewModes.year:
                    case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                        let firstMonth = new Date(baseDateForEnd.valueOf());
                        firstMonth.setMonth(this.yearViewSettings.firstMonthOfYear, 1);
                        baseDateForEnd = dojoDate.add(firstMonth, "month", this.yearViewSettings.monthsCount);
                        baseDateForEnd.setHours(0, 0, 0, 0);
                        baseDateForEnd.setSeconds(-1);
                        return baseDateForEnd;
                        break;

                }
                break;

        }

    }

    public getVisibleDates(): Array<Date> {
        //console.debug();

        let dateList = [];

        if (this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.timelineYear ||
            this.getCurrentViewMode() == WebcalendarTypes.WebCalendar_ViewModes.year) {
            // fix mal ganze Jahr rausrücken, keine dynamisch sichtbaren Dates.
            let date = this.getCurrentSelectedDate("rangeStart");
            let endDate = this.getCurrentSelectedDate("rangeStart");

            while (date.valueOf() == endDate.valueOf()) {
                dateList.push(new Date(date.valueOf()));

                date = dojoDate.add(date, "day", 1);
            }

            return dateList;
        }

        try {
            for (let i = 0; i < this._visibleDateCells.length; i++) {
                let node = this._visibleDateCells[i] as HTMLElement;
                //console.log(node, node.dataset.date, new Date(node.dataset.date));
                let cellDate = new Date(parseInt(node.dataset.date));
                if (cellDate) {
                    dateList.push(cellDate);
                }
            };

            if (dateList.length == 0 && this._firstVisibleCell) {
                let cellDate = new Date(parseInt(this._firstVisibleCell.dataset.date));
                if (cellDate && cellDate.valueOf && cellDate.getDate) {
                    dateList.push(cellDate);
                }
            }

            dateList.sort((a, b) => {
                return a.getTime() - b.getTime(); // sort dates ASC
            });
        } catch (ex) {
            console.error(this.id + ": error getting visible dates", ex);
        }
        return dateList;
    }

    public getRangeDateLimitMax() {
        if (!this.timelineRanges?.length) return null;
        let maxIndex = this.timelineRanges.length - 1;
        if (maxIndex >= 0) {
            return this.timelineRanges[maxIndex].latestDate;
        }
    }
    public getRangeDateLimitMin() {
        if (!this.timelineRanges?.length) return null;
        return this.timelineRanges[0].earliestDate;
    }

    public getIndexOfRange(targetDate?: Date): number {
        if (!targetDate) targetDate = this.scrollDate;

        let bIsInRange = false;
        let actualRangeIndex: number = -1;
        for (let range of this.timelineRanges) {
            actualRangeIndex++;
            if (targetDate.valueOf() >= range.earliestDate.valueOf() &&
                targetDate.valueOf() <= range.latestDate.valueOf()) {
                bIsInRange = true;
                break;
            }
        }

        if (bIsInRange) return actualRangeIndex;
        return -1;
    }

    _viewPortObserver: IntersectionObserver = null;

    startViewportObserver(): void {
        this._visibleDateCells = [];

        let dateNodes = dojoQuery(".e-header-cells");
        if (dateNodes.length == 0) {
            return;
        }

        let maxViewport = this.syncFusionContainer.clientWidth;
        let firstNode = dateNodes[0] as HTMLElement;
        let headerCellWidth = firstNode.clientWidth;

        let threshold = 0.8;


        // dann müssen wir die Empfindlichkeit für den Observer hochschrauben (also Threshold runter)
        let fraction = maxViewport / headerCellWidth;

        // threshold grob vom Ergebnis ermitteln:
        if (fraction < 0.2) threshold = 0.05;
        else if (fraction < 0.6) threshold = 0.2
        else if (fraction < 0.8) threshold = 0.3
        else if (fraction < 0.9) threshold = 0.33

        else if (fraction > 2) threshold = 0.7;
        else if (fraction > 1.2) threshold = 0.6;
        else if (fraction > 1) threshold = 0.48;

        //console.debug("ViewportObserver starting, threshold", threshold, "max vw: " + maxViewport, "cell width: " + headerCellWidth, "fr: " + fraction, dateNodes );



        if (this._viewPortObserver != null) {
            this._viewPortObserver.disconnect();
            this._viewPortObserver = null;
        }

        this._viewPortObserver = new IntersectionObserver(lang.hitch(this, this._viewportObserverCallback), {
            threshold: [threshold]
        });


        dateNodes.forEach((node: Element) => {
            this._viewPortObserver.observe(node);
        });

        //this.emitTimelineScroll(this.scrollDate);
    }

    /**
     * Den Scheduler versuchen lassen ein Intervall vor- oder zurückzuscrollen
     * Falls nicht gescrollt werden kann (Kalendermodus, oder Ende der Timeline) wird gewöhnlich der nächste Bereich geladen.
     * @param amount
     */
    step(amount: number | "min" | "max") {
        let scheduleObject = this.scheduleObject as SyncFusionCalendarTypes.Syncfusion_ScheduleObject;
        let currentView = this.getCurrentViewMode();

        let targetDate = this.getRangeDateLimitMax();
        let mode = "number";

        if (amount === "min") {
            amount = -1;
            targetDate = this.getRangeDateLimitMin();
            mode = "range";
        } else if (amount === "max") {
            amount = 1;
            mode = "range";
        }

        // was ist aktuell sichtbar?
        let dates = this.getVisibleDates();
        let firstVisibleDate = dates[0];
        let lastVisibleDate = dates[dates.length - 1];

        let firstVisibleDateStr = this.dateTimeToString(firstVisibleDate, "yyyy-MM-dd");
        let lastVisibleDateStr = this.dateTimeToString(lastVisibleDate, "yyyy-MM-dd");
        let rangeEndStr = this.dateTimeToString(this.getRangeDateLimitMax(), "yyyy-MM-dd");
        let rangeStartStr = this.dateTimeToString(this.getRangeDateLimitMin(), "yyyy-MM-dd");

        if (typeof amount == "number" && mode === "number") {
            let modifier = -2;
            if (firstVisibleDateStr == rangeStartStr) {
                //modifier = 2;
            } else if (lastVisibleDateStr == rangeEndStr && amount > 0) {
                // wenn wir nach hinten steppen und das Ende der Range schon in Sicht ist, dann den modifier erhöhen
                // das wird das TargetDate auf einen Wert HINTER der Range setzen und damit ggf. eine neue Range laden
                modifier = 2;
            }


            switch (currentView) {
                case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:
                    targetDate = dojoDate.add(firstVisibleDate, "day", amount);
                    break;
                case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:
                    if (modifier < 0) modifier = 0;
                    targetDate = dojoDate.add(firstVisibleDate, "day", amount + modifier);
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                    targetDate = dojoDate.add(firstVisibleDate, "day", amount * (dates.length + modifier));
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                    targetDate = dojoDate.add(firstVisibleDate, "year", amount * 1);
                    break;
            }

        }
        //let targetDate = dojoDate.add(firstDate, "month", amount);

        // ist das noch in der Range? (ggf. zum Minimum/Maximum der Range scrollen)
        let bIsInRange: boolean = this.getIndexOfRange(targetDate) != -1;

        if (!bIsInRange) {
            // nicht in Range - zum Limit springen?
            let minDate = this.getRangeDateLimitMin();
            let maxDate = this.getRangeDateLimitMax();
            if (amount < 0 && targetDate.getTime() < minDate.getTime()) {
                targetDate = new Date(minDate.getTime());
            } else if (amount >= 1 && targetDate.getTime() > maxDate.getTime()) {
                targetDate = new Date(maxDate.getTime());
            }

            bIsInRange = this.getIndexOfRange(targetDate) != -1;
        }


        // ist das Targetdate schon das aktuelle scrollDate und ist das an einer der Grenzen der Range?
        let targetStr = this.dateTimeToString(targetDate, "yyyy-MM-dd");
        let scrollDateStr = this.dateTimeToString(this.scrollDate, "yyyy-MM-dd");

        //console.debug(this.id + " step: visibleDates:", dates, "scrollDate: " + scrollDateStr, "targetDate: " + targetStr, "is in Range? " + bIsInRange);

        if (targetStr == scrollDateStr) {

            // hier bin ich, wenn beim VORIGEN Klick schon die Grenze erreicht (gedeckelt) wurde
            switch (currentView) {
                case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                    this.setScheduleSelectedDate(dojoDate.add(this.scheduleObject.selectedDate, "year", amount));

                    // scroll into view
                    setTimeout(lang.hitch(this, function () {

                        this.startViewportObserver();
                        this.scrollTo(null, this.scrollDate);

                        this.scrollDateLocked = false;

                    }), 3000);

                    break;
                case WebcalendarTypes.WebCalendar_ViewModes.timelineOverview:
                    this.setScheduleSelectedDate(dojoDate.add(this.scheduleObject.selectedDate, "month", 3));

                    // scroll into view
                    setTimeout(lang.hitch(this, function () {

                        this.startViewportObserver();
                        this.scrollTo(null, this.scrollDate);

                        this.scrollDateLocked = false;

                    }), 3000);

                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineDetail:

                    this.setScheduleSelectedDate(dojoDate.add(this.scheduleObject.selectedDate, "day", amount * 3));

                    // scroll into view
                    setTimeout(lang.hitch(this, function () {

                        this.startViewportObserver();
                        this.scrollTo(null, this.scrollDate);

                        this.scrollDateLocked = false;

                    }), 3000);


                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.timelineDay:

                    this.setScheduleSelectedDate(dojoDate.add(this.scheduleObject.selectedDate, "day", amount));

                    // scroll into view
                    setTimeout(lang.hitch(this, function () {

                        this.startViewportObserver();
                        this.scrollTo(null, this.scrollDate);

                        this.scrollDateLocked = false;

                    }), 3000);


                    break;
            }
            return;
        }

        if (bIsInRange) {
            let foundTarget = false;

            try {
                let dateNodes = dojoQuery(".e-header-cells");
                let _self = this;

                for (let i = 0; i < dateNodes.length; i++) {
                    let node = dateNodes[i] as HTMLElement;

                    let cellDate = new Date(parseInt(node.dataset.date));
                    let cellStr = _self.dateTimeToString(cellDate, "yyyy-MM-dd"); // reicht für die Monatstimeline
                    let targetStr = _self.dateTimeToString(targetDate, "yyyy-MM-dd"); // reicht für die Monatstimeline

                    //let workCellNodes = dojoQuery(_self.stringFormat(".e-work-cells[data-date={0}]", node.dataset.date));


                    if (cellStr == targetStr) {
                        let previousX = node.scrollLeft;
                        node.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
                        //let newX = node.scrollLeft;

                        //let dataNodes = dojoQuery(_self.stringFormat(".e-work-cells.e-child-node[data-date={0}]", node.dataset.date));
                        //for (let i = 0; i < dataNodes.length; i++) {
                        //    let contentNode = dataNodes[i] as HTMLElement;
                        //    contentNode.scrollBy({ left: newX - previousX, behavior: "smooth" });
                        //    break;
                        //}

                        this.scrollDateLocked = false;
                        setTimeout(lang.hitch(this, this.scrollTo, null, targetDate), 10);
                        //setTimeout(lang.hitch(this, this.emitTimelineScroll, targetDate), 1000);
                        //this.

                        foundTarget = true;
                        break;
                    }
                };


            } catch (ex) {
                console.warn(this.id + ": scrolling to target failed", ex);
            }

            if (foundTarget) {
                this.scheduleObject.scrollTo(null, targetDate);
            }

            //setTimeout(lang.hitch(this, this.emitTimelineScroll, targetDate), 100);
            //this.emitTimelineScroll(targetDate);
            return;
        }
        else {
            // immer noch nicht in der Range? dann Range umschalten!

        }


        // falls bereits am Anfang der Range: vorherige/nächste Range komplett laden
    }

    scrollTo(entity: any, date?: Date) {
        if (!entity && !date) {
            return;
        }
        //console.debug(this.id + " scrollTo", date);

        let dateNodes = dojoQuery(".e-header-cells");
        let _self = this;

        //this.scrollDateLocked = false;


        for (let i = 0; i < dateNodes.length; i++) {
            let node: HTMLElement = dateNodes[i] as HTMLElement;

            let cellDate = new Date(parseInt(node.dataset.date));
            let cellStr = _self.dateTimeToString(cellDate, "yyyy-MM-dd"); // reicht für die Monatstimeline
            let targetStr = _self.dateTimeToString(date, "yyyy-MM-dd"); // reicht für die Monatstimeline


            if (cellStr == targetStr) {
                node.scrollIntoView({ inline: "start" });
                this.scheduleObject.scrollTo(entity, cellDate);
                //this.emitTimelineScroll(cellDate);
                break;
            }
        }

        let currentView = this.getCurrentViewMode();
        if (currentView == WebcalendarTypes.WebCalendar_ViewModes.timelineOverview) {

            // das führt im Detailmodus dazu dass es wieder zurückspringt. warum??
            //if (entity || date) {
            //    this.scheduleObject.scrollTo(entity, date);
            //}

            //this.emitTimelineScroll(date);

        }
        else if (currentView == WebcalendarTypes.WebCalendar_ViewModes.timelineDetail) {
            let headerRow = dojoQuery(".e-date-header-wrap")[0] as HTMLElement;
            let mainContainer = dojoQuery(".e-content-wrap")[0] as HTMLElement;
            if (headerRow && mainContainer) {
                mainContainer.scrollLeft = headerRow.scrollLeft;
            }
        } else {
            this.scheduleObject.scrollTo(entity, date);
        }
    }


    /**
     * Set scheduler view mode.
     * */
    changeView(view: WebcalendarTypes.WebCalendar_ViewModes | WebcalendarTypes.WebCalendar_ViewInstructions): void {
        let delay = 10;
        if (!this.isViewAlreadySelected(view)) {
            let currentViewDates = this.scheduleObject.getCurrentViewDates();
            //this.loadCalendarData(currentViewDates[0], currentViewDates[currentViewDates.length - 1]);
            //this.showLoadingScreen('ViewMode');
            this.disableNode(this.syncFusionContainer);

            // wenn sich tatsächlich die Ansicht ändert und ein Scrolldate hinterlegt war, dieses als neues gewähltes Datum verwenden!
            switch (view) {
                case WebcalendarTypes.WebCalendar_ViewModes.week:
                case WebcalendarTypes.WebCalendar_ViewModes.month:
                case WebcalendarTypes.WebCalendar_ViewModes.year:
                case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                case WebcalendarTypes.WebCalendar_ViewModes.day:
                case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                case WebcalendarTypes.WebCalendar_ViewInstructions.today:
                    if (this.scrollDate) {

                        if (this.currentView != view) {
                            this.selectedDate = this.scrollDate;
                            //    this.scheduleObject.selectedDate = this.selectedDate; // dadurch wird das selecteddate teilweise wieder zurückgestellt!!
                        }
                        break;
                    }
            }

            switch (view) {
                case WebcalendarTypes.WebCalendar_ViewModes.week:
                    this.scheduleCalendarInterval = 1;
                    this._isTimelineMode = false;
                    this.scrollDate = null;
                    this.currentView = view;
                    this._selectScheduleView("Week");
                    break;
                case WebcalendarTypes.WebCalendar_ViewModes.month:
                    this.scheduleCalendarInterval = 1;
                    this._isTimelineMode = false;
                    this.scrollDate = null;
                    this.currentView = view;
                    this._selectScheduleView("Month");
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.year:
                case WebcalendarTypes.WebCalendar_ViewModes.timelineYear:
                    this.scheduleCalendarInterval = 1;
                    this.setYearViewParameters(this.yearViewSettings);
                    this._isTimelineMode = view == WebcalendarTypes.WebCalendar_ViewModes.timelineYear;
                    this.scrollDate = null;
                    this.currentView = view;
                    this._selectScheduleView("Year");
                    break;

                case WebcalendarTypes.WebCalendar_ViewModes.day:
                    this.scheduleCalendarInterval = 1;
                    this._isTimelineMode = false;
                    this.scrollDate = null;
                    this.currentView = view;
                    this._selectScheduleView("Day");
                    break;
                case WebcalendarTypes.WebCalendar_ViewModes.threeDays:
                    this.scheduleCalendarInterval = 3;
                    this._isTimelineMode = false;
                    this.scrollDate = null;
                    this.currentView = view;
                    this._selectScheduleView("Day");
                    break;
                case WebcalendarTypes.WebCalendar_ViewModes.twoWeeks:
                    this.scheduleCalendarInterval = 2;
                    this._isTimelineMode = false;
                    this.scrollDate = null;
                    this.currentView = view;
                    this._selectScheduleView("Week");
                    break;
                case WebcalendarTypes.WebCalendar_ViewInstructions.today:
                    if (this.isTimeLineMode()) {
                        let index = this.getIndexOfRange(new Date());
                        if (index != -1) {
                            this.scrollTo(null, new Date());
                            this.disableNode(this.syncFusionContainer, false);

                        } else {
                            this.scrollDate = new Date();
                            //this.setScheduleViewTimeline(); // funzt nicht fehlerfrei...
                            this.setScheduleSelectedDate(this.scrollDate);

                            setTimeout(lang.hitch(this, this.scrollTo, null, new Date()), 3000);
                        }

                    } else {
                        //this.scrollDate = new Date();
                        this.scrollDate = null;
                        this.setScheduleSelectedDate(new Date());

                        //this.scheduleObject.selectedDate = new Date();
                        //topic.publish("calendar/loadData", delay);

                        //    this.scheduleCalendarInterval = 1;
                        //    this.selectScheduleView("Day");
                    }
                    //this.hideLoadingScreen("ViewMode");
                    //this.disableNode(this.syncFusionContainer, false);

                    break;
                case WebcalendarTypes.WebCalendar_ViewInstructions.next:
                    switch (this.scheduleObject.currentView as WebcalendarTypes.SyncfusionCalendar_ViewModes) {
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.Day:
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.TimelineDay:
                            this.scheduleObject.selectedDate =
                                this.scheduleObject.selectedDate.setDate(this.scheduleObject.selectedDate.getDate() + this.scheduleCalendarInterval);
                            break;
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.Week:
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.TimelineWeek:
                            this.scheduleObject.selectedDate =
                                this.scheduleObject.selectedDate.setDate(this.scheduleObject.selectedDate.getDate() + (this.scheduleCalendarInterval * 7));
                            break;
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.Month:
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.TimelineMonth:
                            this.scheduleObject.selectedDate =
                                this.scheduleObject.selectedDate.setMonth(this.scheduleObject.selectedDate.getMonth() + this.scheduleCalendarInterval);
                            break;
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.Year:
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.TimelineYear:
                            let newNextDate = dojoDate.add(this.scheduleObject.selectedDate, "month", 12); // muss immer 12 sein, sonst muss Startmonat umgestellt werden etc this.yearViewSettings.monthsCount);
                            this.scheduleObject.selectedDate = newNextDate;
                            this.scrollDate = newNextDate;
                            break;
                    }

                    if (this.isTimeLineMode()) {
                        setTimeout(lang.hitch(this, this.scrollTo, null, this.scrollDate), 3000);
                    } else {
                        //this.scrollDate = this.scheduleObject.selectedDate ? this.scheduleObject.selectedDate : this.scrollDate;
                    }
                    //this.hideLoadingScreen('ViewMode');
                    //this.disableNode(this.syncFusionContainer, false);
                    topic.publish("calendar/loadData", delay);
                    break;
                case WebcalendarTypes.WebCalendar_ViewInstructions.previous:
                    switch (this.scheduleObject.currentView) {
                        case 'Day':
                        case 'TimelineDay':
                            this.scheduleObject.selectedDate =
                                this.scheduleObject.selectedDate.setDate(this.scheduleObject.selectedDate.getDate() - this.scheduleCalendarInterval);
                            break;
                        case 'Week':
                        case 'TimelineWeek':
                            this.scheduleObject.selectedDate =
                                this.scheduleObject.selectedDate.setDate(this.scheduleObject.selectedDate.getDate() - (this.scheduleCalendarInterval * 7));
                            break;
                        case 'Month':
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.TimelineMonth:
                            this.scheduleObject.selectedDate =
                                this.scheduleObject.selectedDate.setMonth(this.scheduleObject.selectedDate.getMonth() - this.scheduleCalendarInterval);
                            break;

                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.Year:
                        case WebcalendarTypes.SyncfusionCalendar_ViewModes.TimelineYear:
                            let newPreviousDate = dojoDate.add(this.scheduleObject.selectedDate, "month", -12);// muss immer 12 sein, sonst muss Startmonat umgestellt werden etc this.yearViewSettings.monthsCount * -1);
                            this.scheduleObject.selectedDate = newPreviousDate;
                            this.scrollDate = newPreviousDate;
                            break;
                    }
                    if (this.isTimeLineMode()) {
                        setTimeout(lang.hitch(this, this.scrollTo, null, this.scrollDate), 3000);
                    } else {
                        //this.scrollDate = this.scheduleObject.selectedDate ? this.scheduleObject.selectedDate : this.scrollDate;
                    }
                    //this.hideLoadingScreen('ViewMode');
                    //this.disableNode(this.syncFusionContainer, false);
                    topic.publish("calendar/loadData", delay);
                    break;
            }
        } else {
            //
        }
    }

    /**
     * Set the main selected date of the scheduler.
     * Der Kalender stellt sich auf das neue Datum, zeichnet die Oberfläche neu und löst einen Load-Request aus.
     * */
    setScheduleSelectedDate(date: Date, lockScrollDate: boolean = true): void {

        if (!date) return;
        if (!date.valueOf || !date.getDate) return;

        //console.debug(this.id + " setScheduleSelectedDate", date, "lockscroll? ", lockScrollDate);

        if (this._isTimelineMode && this.resources.length > 0) {
            //this.StandbyStart(this.syncFusionContainer);
        }

        let viewMode = this.getPrimitiveViewMode();

        switch (viewMode) {
            case WebcalendarTypes.WebCalendar_ViewTypes.week:
                if (date.getDay() === 0) {
                    date = dojoDate.add(date, "day", -6);
                }
                break;
            default:

                break;
        }

        if (lockScrollDate === false) {
            this.scrollDate = date;
        } else {
            this.scrollDateLocked = true;
        }

        //this.scrollDate = date;

        this.disableNode(this.syncFusionContainer);


        let earliestValue: number = date.valueOf();;
        let latestValue: number = earliestValue;
        if (this.earliestDate) {
            earliestValue = this.earliestDate.valueOf();
        }
        if (this.latestDate) {
            latestValue = this.latestDate.valueOf();
        }

        if (date.valueOf() < earliestValue || date.valueOf() > latestValue) {
            //this.StandbyStart(this.syncFusionContainer);
            this.earliestDate = null;
            this.latestDate = null;
        }

        this.scheduleObject.selectedDate = date; // Kalender zeichnet sich dadurch neu

        // Range befüllen
        this._createRangeRegistry(date);

        topic.publish("calendar/loadData", 100);

    }

    /**
     * Set the dialog method to show the event details on click.
     * */
    setItemClickFunction(method: Function): void {
        this.itemClickFunction = method;
    }

    setColumnView_bodyText_attribute(value: string): void {
        this.columnView_bodyText_attribute = value;
    }

    setColumnView_headText_attribute(value: string): void {
        this.columnView_headText_attribute = value;
    }

    isTimeLineMode(): boolean {
        return this._isTimelineMode;
    }

    private _checkResetTimelineMode(): void {
        // Reset configuration, if it is changed from the backend to something else like three days, week or two weeks.
        if (this._isTimelineMode &&
            this.getCurrentViewMode() !== WebcalendarTypes.WebCalendar_ViewModes.timelineDay &&
            this.getCurrentViewMode() !== WebcalendarTypes.WebCalendar_ViewModes.timelineYear &&
            this.getCurrentViewMode() !== WebcalendarTypes.WebCalendar_ViewModes.timelineDetail &&
            this.getCurrentViewMode() !== WebcalendarTypes.WebCalendar_ViewModes.timelineOverview) {

            //console.debug(this.id + " reset timeline config", this.scheduleObject.currentView);
            this.scheduleCalendarInterval = 1;
            this._selectScheduleView("Day");
        }
    }


    /**
     * Check if a view with the correct interval is already selected.
     * */
    private isViewAlreadySelected(view: string): boolean {
        switch (view?.toUpperCase()) {
            case 'WEEK':
            case 'WOCHE':
                return this.scheduleObject.currentView === 'Week' && this.scheduleCalendarInterval === 1;
            case 'MONTH':
                return this.scheduleObject.currentView === 'Month' && this.scheduleCalendarInterval === 1;
            case 'YEAR':
                return this.scheduleObject.currentView === 'Year' && this.scheduleCalendarInterval === 1;
            case 'DAY':
                return this.scheduleObject.currentView === 'Day' && this.scheduleCalendarInterval === 1;
            case 'THREEDAYS':
                return this.scheduleObject.currentView === 'Day' && this.scheduleCalendarInterval === 3;
            case 'TWOWEEKS':
                return this.scheduleObject.currentView === 'Week' && this.scheduleCalendarInterval === 2;
            case 'TODAY':
                return this.scheduleObject.currentView === 'Day' && this.scheduleCalendarInterval === 1
                    && this.dateToString(this.scheduleObject.selectedDate, "yyMMdd") === this.dateToString(new Date(), "yyMMdd");
            default:
                return false;
        }
    }

    /**
     * Stellt im Syncfusion-Kalender die tatsächlich gewählte Ansicht ein.
     * Select view and scheduler mode.
     * Also, for some reason, if you switch between modes (Day, 3 Days, Week etc.) with room resources added, are getting removed.
     * For the time being, resources are added back if you change mode.
     * */
    private _selectScheduleView(option: "Day" | "Week" | "Month" | "Year", targetDate?: Date): void {


        const viewOption = this._isTimelineMode ? 'Timeline' + option : option;

        //console.debug(this.id + " selectScheduleView", option, targetDate, this._isTimelineMode, viewOption);

        // die intern registrierten Viewmodes durchlaufen und die passende aufgrund von Interval etc selecten
        for (let view of (this.scheduleObject as SyncFusionCalendarTypes.ScheduleObject_Stump).views) {
            if (view.option === viewOption && view.interval === this.scheduleCalendarInterval) {
                view.isSelected = true;
            } else {
                view.isSelected = false;
            }
        }

        if (!this._isTimelineMode) {
            this.scheduleObject.timeScale = this.scheduleObject.timeScale_default;
        } else {
            switch (option) {
                case "Day":
                case "Week":
                    this.scheduleObject.timeScale = {
                        enable: true,
                        interval: 60,
                        slotCount: 2
                    };


                    break;

                case "Month":
                    this.scheduleObject.timeScale = {
                        enable: true,
                        interval: 120,
                        slotCount: 1
                    };


                    break;

                case "Year":
                    this.scheduleObject.timeScale = {
                        enable: true,
                        interval: 120,
                        slotCount: 1
                    };
                    this.setYearViewParameters(this.yearViewSettings);
                    this.scheduleObject.rowAutoHeight = true; // auto-Höhe für die Monatszeilen, wenn viele Einträge vorhanden sind

                    break;
            }
        }


        if (this._isTimelineMode && this.resources.length > 0 && this.scheduleObject.group.resources.includes('Resources')) {
            this.scheduleObject.resources[1].dataSource = <Object[]>window.ej.base.extend([], this.resources, null, true);
        }

        // danach den Kalender einmal neu rendern lassen, der zeichnet wegen der neu selektierten View die Oberfläche neu:
        this.scheduleObject.refresh(); // ohne wird die Oberfläche nicht umgeschaltet auf den neuen Modus!

        if (targetDate) {
            setTimeout(lang.hitch(this, this.setScheduleSelectedDate, targetDate), 20);
        } else {
            topic.publish("calendar/loadData", 200);
        }
        this.hideLoadingScreen('ViewMode');
    }

    /**
     * Check if the list of groups already contains this group.
     * */
    private hasGroup(groups: SyncFusionCalendarTypes.EventGroup[], groupId: string): boolean {
        for (let i = 0; i < groups.length; i += 1) {
            const group = groups[i];
            if (group.id === groupId) {
                return true;
            }
        }
        return false;
    }

    /**
     * Fallback for showing the details dialog of an event.
     * */
    private setDefaultItemClickFunction(): void {

        this.itemClickFunction = function (item: any) { // Default

            if (this.dlg != null) {
                if (this.dlg.modalDlgNode) this.dlg.close();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();

            this.dlg.set('header', item[this.columnView_headText_attribute]);
            this.dlg.set('content', item[this.columnView_bodyText_attribute]);
            this.dlg.set('closeBtn', true);

            this.dlg.show();
        }
    }

    /**
     * Set a custom opacity to a hexadecimal color.
     * */
    private setOpacityHex(color: string, opacityHex: string): string {
        //// "#" + 6 characters color + 2 characters opacity
        let result: string = '';
        if (/^#?[0-9A-F]{6}$/i.test(color) || /^#?[0-9A-F]{8}$/i.test(color)) { // is it a hex color?
            if (color.trim().indexOf('#') == -1) {
                color = '#' + color;
            }

            if (color.length == 7) {
                result = color + opacityHex;
            } else if (color.length == 9) {
                result = color.slice(0, 7) + opacityHex;
            } else {
                console.log('not a valid HEX color');
            }

        } else {
            console.log('please use hex colors')
        }

        return result;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.useStandbyManager = true;

        this.itemColorationValues = [];

        this.addSubscription("sidebar/closed", lang.hitch(this, this.redrawEvents));
        this.addSubscription("sidebar/opened", lang.hitch(this, this.redrawEvents));

        // sachen wegblenden in  der sidebar wenn der calendar im teams tab verwendet wird
        window.msTeamsSimpleApi?.onIsTeams(lang.hitch(this, () => {
            document.body.classList.add("msTeamsTabModeSfC");
        }));

        this.on("viewChange", lang.hitch(this, this.tooltip_ClearCache));
        this.on("calendarPageChange", lang.hitch(this, this.tooltip_ClearCache));

        if (this.hasFeature("Webcalendar", "TimeLineAutoCollapseAppointments")) {
            this.enableTimelineGroupCollapse = true;
        }
        else {
            this.enableTimelineGroupCollapse = false;
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}

//on import laden damit sichs ausgeht
ExtraHelpers.sideLoadResource(SyncfusionHelper.getSfLangScriptPath(), 'js').then(() => {
    SyncfusionHelper.getSyncfusionLangObj(window.currentLanguageCode2 ?? "en");
});

mdsLazyProto(SyncFusionCalendar.prototype, {
  tooltipQueue: () => (new ExtraHelpers.AsyncOperationQueue(2)),
});
export default mdsWidget(SyncFusionCalendar);
